import { useState, useEffect } from 'react';
import { createPublicClient, http, formatEther, formatUnits, createWalletClient, custom, parseEther, parseGwei } from 'viem';
import { coreDao } from 'viem/chains';

import './backhand_style.css';
import './backhand_media-queries.css';


import core_1 from './assets_2/core_1.png';


import { useAccount } from 'wagmi';

import { Test_CoreDao } from './Core_Test_Network';

import loading_gif from './images/loading_gif.gif';

import Gen_8_Con from './contracts/CoreUnity/Gen_8.json';
import Gen_8_Cal_Con from './contracts/CoreUnity/Gen_8_Cal.json';
import Gen_8_RR_Con from './contracts/CoreUnity/Gen_8_Recent_Record.json';

import Fixed_Pool_Con from './contracts/CoreUnity/Fixed_Pool.json';
import Fixed_Pool_Data_Con from './contracts/CoreUnity/Fixed_Pool_Data.json';

import { data } from 'react-router-dom';


export const Gen_8 = {
    // address: "0x806bDFb796B0AA06c9cC1B569EACB5bE8d6e1dA6",
    // address: "0x8657d2D12DA3f29287A9F1b7923CC0dd89719D08",
    address: "0x5C20320C70FBE0D995b1d9bCDF553a5E1F801C49",
    abi: Gen_8_Con.abi
}
export const Gen_8_Cal = {
    // address: "0x969a632bB68Bd32546B69681b7040A3021BADa8b",
    // address: "0x45dEed2b1d4bAf77F5324E3f81C2dC2Cd17F6CAB",
    address: "0x292FA97D724Ab1Da260528aBA4889544821Dd03c",
    abi: Gen_8_Cal_Con.abi
}
export const Gen_8_RR = {
    // address: "0x2f3cf1DA78eb6fB3B0Cb2A3bfE45F1da29DAaaf5",
    // address: "0xe5fa6072083A365B39DdbaA9f9C32c310Ee3B662",
    address: "0x500fac0fad907cCaA661f7074A5e29eDaC256Df9",
    abi: Gen_8_RR_Con.abi
}

export const Fixed_Pool = {
    // address: "0x7d47e92a01d3A63cA08a50175E8CFF44dacF905e",
    // address: "0xf4407561BCE412fa19767723b2dAe2fB5f19afA9",
    address: "0xE6685e174f498d9aA389dAd32ad4B3899768CA1B",
    abi: Fixed_Pool_Con.abi
}
export const Fixed_Pool_Data = {
    // address: "0x9448AC5aa4310C690FEF88EcAA37C49dd634594A",
    // address: "0x5BAa6045Acb4f14E50B09301499BcB847c6cfC37",
    address: "0x1De96c49E4B246b01Acd0A989dcFA414ee852F83",
    abi: Fixed_Pool_Data_Con.abi
}


const p_chain = coreDao;
// const p_chain = Test_CoreDao;

//"https://core.drpc.org";//

// "https://1rpc.io/core"
// 
//'https://1rpc.io/core'
//'https://core.public-rpc.com/'

const p_transport = "https://rpc.coredao.org";//"https://1rpc.io/core";//"https://rpc.ankr.com/core"; //"https://rpc.coredao.org";
// const p_transport = "https://rpc.test2.btcs.network";

const client = createPublicClient({
  chain: p_chain,
  transport: http(p_transport)
});

 
let Dai_deceimals = Number(4);
let Core_deceimals = Number(4);//2);

// let Symbol = "DAI";
let Symbol = "CORE";

// let url = "https://coreyards.space/";
let url = "https://coreunity.space/";
// let url = "http://localhost:3000/";

let type_url = "https://scan.coredao.org/address/";
// let type_url = "https://scan.test2.btcs.network/address/";

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
//-------------------------------------------For_Nutral-------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

function Loading_Component(props) {

    return (
        <>
            <img style={{width: '30px', height: '30px'}} src={loading_gif} alt="loading" />
        </>
    );
}
function Card_LC(props) {

    return (
        <>
            <img style={{width: '15px', height: '15px'}} src={loading_gif} alt="loading" />
        </>
    );
}

//-----Search_Function_Area------------------

export async function Copy(data, showAlert) {
    if (data === '') {}
    else {
        navigator.clipboard.writeText(data);
        showAlert(data + " Copied!...", 'success', true);
    }
}
export async function Check_Add(data, showAlert) {
    if (data === '') {}
    else {
        navigator.clipboard.writeText(type_url + "" + data);
        showAlert(type_url + "" + data + " Copied!...", 'success', true);
    }
} 

export function GetDate() {
    
    let dt = new Date();
    let datetime = [];

    datetime[1] = dt.getFullYear();
    datetime[2] = (dt.getMonth() + 1);
    datetime[3] = dt.getDate();

    return (datetime)
}
export function Sub_Variable(data) {
    //console.log("_____________________");
    //console.log(data);
    if(data) {//(data !== "" || data !== undefined) {
        // let var_data = data.substring(0, 10) + "......" + data.substring(31, 41);
        let var_data = data.substring(0, 6) + "......" + data.substring(37, 41);
        //console.log(var_data);
        return var_data;
    }
    else {
        return "";
    }
}
export function Sub_Ref_Variable(data) {
    //console.log("_____________________");
    //console.log(data);
    if(data) {//(data !== "" || data !== undefined) {
        let var_data = data.substring(0, 11) + "..." + data.substring(27, 34);
        //console.log(var_data);
        return var_data;
    }
    else {
        return "";
    }
}
function Format_Dai(data) {
    return Number(formatEther(BigInt(data))).toFixed(Dai_deceimals);
}
function Format_Core(data) {
    return Number(formatEther(BigInt(data))).toFixed(Core_deceimals);
}
function Format_Core_For_Fix(data) {
    return Number(formatEther(BigInt(data))).toFixed(Number(2));
}

function IsSymbol() {
    return (
        <>
            {
                Symbol === "DAI" ? (
                    <>{Symbol}</>
                ) : (
                    <> {Symbol}</>
                )
            }
        </>
    )
}

async function Format_UTC(data) {
    //console.log(data);
    let dt_arr = new Date(Number(String(data) + String("000")));
    //console.log(dt_arr);
    let datetime = dt_arr.toLocaleString();
    //console.log(datetime);
    return datetime;
}

function Is_Value_Format(data) {
    return (
        <>
            {
                Symbol === "DAI" ? (
                    <>{Format_Dai(data) + " " + Symbol}</>
                ) : (
                    <>{Format_Core(data) + " " + Symbol}</>
                )
            }
        </>
    );
} 
function Is_Value_Format_Without_Symbol(data) {
    return (
        <>
            {Format_Core(data)}
        </>
    );
}
// function Is_Value_Icon() {
//     return (
//         <>
//             {
//                 Symbol === "DAI" ? (
//                     <>{Symbol}</>
//                 ) : (
//                     <>
//                         <div class="c-logo-grid">
//                             <span><img src={core_3} alt=""/></span>
//                         </div>
//                     </>
//                 )
//             }
//         </>
//     );
// }
function Is_Rank(pack_no) {
    return (
        <>
            {"Rank : " + (pack_no)}
        </>
    );
} 

async function Return_Page_Settings(Total_No) {
    try {
        let Total_No_Length = Number(String(Total_No).length);

        let Num = "";
        for(let i = 1; i <= Total_No_Length; i++) {
            if(Number(i) === Number(1)) {
                Num = "0";
            }   
            else if (Number(i) > Number(1)) {
                Num += String(Number(i-1));
            }
        }

        //console.log(" ");
        //console.log("----------------");
        //console.log(" ");
        //console.log(String(Total_No));
        //console.log(String(Num) + " Length : " + Total_No_Length);
        //console.log(" ");

        if(Number(Total_No) > 9) {
            //console.log(Total_No.toString()[1]); //0 = 1 1 = 0
            //console.log(Total_No.toString().charAt(0)); //0 = 1 1 = 0  
            //console.log(String(Total_No)[String(Total_No.length + 1)] + " +|+ " + String(Total_No)[1] ); //0 = 1 1 = 0  

            let Second_Last = Number(Total_No_Length-2);
            let First_Last = Number(Total_No_Length-1);
            let Total_Last = Number(String(Second_Last) + "" + String(First_Last));
            //console.log("Second_Last : " + Second_Last + " +|+ First_Last : " + First_Last);
            //console.log("Total_Last : " + Total_Last);     
            //console.log(" ");               

            let Second_Last_Value = String(Total_No)[Second_Last];
            let First_Last_Value = String(Total_No)[First_Last];
            let Total_Last_Value = Number(String(Second_Last_Value) + "" + String(First_Last_Value));
            //console.log("Second_Last Value : " + Second_Last_Value + " +|+ First_Last Value : " + First_Last_Value);
            //console.log("Total_Last_Value : " + Total_Last_Value);

            let TLV = Number(Total_Last_Value);

            let Second_Last_Plus_Value;
            if(Number(TLV) === Number(0) || Number(TLV) === Number(20) || Number(TLV) === Number(40) || Number(TLV) === Number(60) || Number(TLV) === Number(80) || Number(TLV) === Number(100)) {
                Second_Last_Plus_Value = 0;
            }
            if(Number(TLV) === Number(10) || Number(TLV) === Number(30) || Number(TLV) === Number(50) || Number(TLV) === Number(70) || Number(TLV) === Number(90)) {
                Second_Last_Plus_Value = 1;
            }
            else {
                if     (Number(TLV) > Number(0) && Number(TLV) < Number(10)) { Second_Last_Plus_Value = String(1); }
                else if(Number(TLV) > Number(10) && Number(TLV) < Number(20)) { Second_Last_Plus_Value = String(0); }
                else if(Number(TLV) > Number(20) && Number(TLV) < Number(30)) { Second_Last_Plus_Value = String(1); }
                else if(Number(TLV) > Number(30) && Number(TLV) < Number(40)) { Second_Last_Plus_Value = String(0); }
                else if(Number(TLV) > Number(40) && Number(TLV) < Number(50)) { Second_Last_Plus_Value = String(1); }
                else if(Number(TLV) > Number(50) && Number(TLV) < Number(60)) { Second_Last_Plus_Value = String(0); }
                else if(Number(TLV) > Number(60) && Number(TLV) < Number(70)) { Second_Last_Plus_Value = String(1); }
                else if(Number(TLV) > Number(70) && Number(TLV) < Number(80)) { Second_Last_Plus_Value = String(0); }
                else if(Number(TLV) > Number(80) && Number(TLV) < Number(90)) { Second_Last_Plus_Value = String(1); }
                else if(Number(TLV) > Number(90) && Number(TLV) < Number(100)) { Second_Last_Plus_Value = String(0); }
            }

            let First_Last_Plus_Value;
            if(Number(First_Last_Value) === Number(0)) { First_Last_Plus_Value = String(0); }
            else if(Number(First_Last_Value) === Number(1)) { First_Last_Plus_Value = String(9); }
            else if(Number(First_Last_Value) === Number(2)) { First_Last_Plus_Value = String(8); }
            else if(Number(First_Last_Value) === Number(3)) { First_Last_Plus_Value = String(7); }
            else if(Number(First_Last_Value) === Number(4)) { First_Last_Plus_Value = String(6); }
            else if(Number(First_Last_Value) === Number(5)) { First_Last_Plus_Value = String(5); }
            else if(Number(First_Last_Value) === Number(6)) { First_Last_Plus_Value = String(4); }
            else if(Number(First_Last_Value) === Number(7)) { First_Last_Plus_Value = String(3); }
            else if(Number(First_Last_Value) === Number(8)) { First_Last_Plus_Value = String(2); }
            else if(Number(First_Last_Value) === Number(9)) { First_Last_Plus_Value = String(1); }

            let Total_Last_Plus_Value = Number(String(Second_Last_Plus_Value) + "" + String(First_Last_Plus_Value));

            //console.log(" ");
            
            //console.log("Second_Last_Plus_Value : " + Second_Last_Plus_Value + " +|+ First_Last_Plus_Value : " + First_Last_Plus_Value);
            //console.log("Total_Last_Plus_Value : " + Total_Last_Plus_Value);
            
            let Total_No_Updated = Number(Number(Total_No) + Number(Total_Last_Plus_Value));

            //console.log(" ");
            //console.log("Total_No_Updated : " + Total_No_Updated);

            let Total_Page = Number(Number(Total_No_Updated) / 20);
            //console.log(" ");
            //console.log("Total_Page : " + Total_Page);
            
            return Total_Page;
            
        }
        else if(Number(Total_No) < 10) {

            let First_Last = Number(Total_No_Length-1);
            //console.log("First_Last : " + First_Last);

            let First_Last_Value = String(Total_No)[First_Last];
            //console.log("First_Last Value : " + First_Last_Value);

            let First_Last_Plus_Value;

            if(Number(First_Last_Value) === Number(0)) { First_Last_Plus_Value = String(0); }
            else if(Number(First_Last_Value) === Number(1)) { First_Last_Plus_Value = String(9); }
            else if(Number(First_Last_Value) === Number(2)) { First_Last_Plus_Value = String(8); }
            else if(Number(First_Last_Value) === Number(3)) { First_Last_Plus_Value = String(7); }
            else if(Number(First_Last_Value) === Number(4)) { First_Last_Plus_Value = String(6); }
            else if(Number(First_Last_Value) === Number(5)) { First_Last_Plus_Value = String(5); }
            else if(Number(First_Last_Value) === Number(6)) { First_Last_Plus_Value = String(4); }
            else if(Number(First_Last_Value) === Number(7)) { First_Last_Plus_Value = String(3); }
            else if(Number(First_Last_Value) === Number(8)) { First_Last_Plus_Value = String(2); }
            else if(Number(First_Last_Value) === Number(9)) { First_Last_Plus_Value = String(1); }

            let Total_No_Updated;
            let Total_Page;
            if(Number(First_Last_Value) === Number(0)) {
                Total_No_Updated = Number(Number(Total_No) + Number(First_Last_Plus_Value) + Number(20));
                Total_Page = 1;
            }
            else if(Number(First_Last_Value) > Number(0)) {
                Total_No_Updated = Number(Number(Total_No) + Number(First_Last_Plus_Value) + Number(10));
                Total_Page = 1;
            }

            //console.log(" ");
            //console.log("Total_No_Updated : " + Total_No_Updated);
            //console.log(" ");
            //console.log("Total_Page : " + Total_Page);

            return Total_Page;

        }
    }
    catch(error) {
        console.log(error);
    }
}

//-------------After-Login-----------------

//----Dashboard--------

export function Dashboard_Form(props) {

    const[Should, SetShould] = useState(true);

    return (
        <>
            {/* <div className="hide-space"></div> */}
            {/* <div className="back-grid-short">                                 
                <div className="heading">
                    <span>Dashboard</span>
                </div>
            </div> */}
            <div className="back-grid">
                <div className="cards">
                    
                    <My_Detail ID_={props.ID_} address={props.address} Should={Should} showAlert={props.showAlert}/>
                    
                    <Per_Detail ID_={props.ID_} ID_Type_={props.ID_Type_} address={props.address} Should={Should}/>
                    
                    <Income_Detail ID_={props.ID_} address={props.address} Should={Should}/>
                    
                    <Team_Detail ID_={props.ID_} address={props.address} Should={Should}/>
                              
                </div>
            </div>
        </>
    );
}

function My_Detail(props) {

    const [Ref_Link, SetRef_Link] = useState(url + "r/" + props.ID_);
    const [Wallet_Fund, SetWallet_Fund] = useState("0.0000");
    const [Today_Income, SetToday_Income] = useState("0.0000");
    const [Rank, SetRank] = useState(0);

    useEffect(() => {
        const Load = async() => {
            try {
                SetRef_Link(Card_LC());

                // console.log(props.ID_);

                SetWallet_Fund(Card_LC());
                
                SetToday_Income(Card_LC());
                SetRank(Card_LC());

                
                let User_BalanceOf = await client.getBalance({address: props.address});

                let today = new Date();
                let yesterday = new Date(today);
                yesterday.setDate(yesterday.getDate() - 1);

                // console.log("Today's date:", today.toDateString());
                // console.log("Yesterday's date:", yesterday.toDateString());

                // console.log("Today: " + today.getFullYear() + " " + (today.getMonth()+1) + " " + today.getDate())
                // console.log("Yesterday: " + yesterday.getFullYear() + " " + (yesterday.getMonth()+1) + " " + yesterday.getDate())

                let today_income_ = await client.readContract({
                    address: Gen_8_RR.address,
                    abi: Gen_8_RR.abi,
                    functionName: "GetDateTime_ID_Reward",
                    args: [props.ID_, today.getFullYear(), (today.getMonth()+1), today.getDate()]
                });
                
                let rank_ = await client.readContract({
                    address: Gen_8.address,
                    abi: Gen_8.abi,
                    functionName: "GetUser_Pack_No",
                    args: [props.ID_]
                });

                // console.log("Wallet Fund: " + User_BalanceOf);
                // console.log("Today Fund: " + today_income_);

                SetRef_Link(url + "r/" + props.ID_);
                SetWallet_Fund(Is_Value_Format(User_BalanceOf));
                SetToday_Income(Is_Value_Format(today_income_));
                SetRank(Number(rank_));
                
            }
            catch(error) {
                console.log(error);

                SetWallet_Fund("0.0000");
                SetToday_Income("0.0000");
                SetRank(0);
            }
        }
        Load();
    }, [props.Should, props.ID_]);
    return (
        <>
            <div className="card-single">
                <div className="card-single-header">
                    <div>Refferal link</div>
                    <div className="r-link">
                        <span>{Ref_Link}</span>
                    </div>
                    <div className="copy-link">
                        <button className="btn" onClick={() => {Copy(Ref_Link, props.showAlert)}}>
                            <div>Copy</div>
                        </button> 
                    </div>
                </div>
                <div className="card-single-header">
                    <div>Wallet_Fund</div>                      
                    <div className="all-detail">
                        <span>{Wallet_Fund}</span>
                    </div> 
                </div>
                <div className="card-single-header">
                    <div>Today_Income</div>                      
                    <div className="all-detail">
                        <span>{Today_Income}</span>
                    </div> 
                </div>
                <div className="card-single-header">
                    <div>My_Rank</div>                      
                    <div className="all-detail">
                        <span>{Rank}</span>
                    </div> 
                </div>
            </div>
        </>
    );
}
function Per_Detail(props) {

    const [Sponser_ID, SetSponser_ID] = useState("");

    useEffect(() => {
        const Load = async() => {
            try {
                SetSponser_ID(Card_LC());
            
                let ref_Id = await client.readContract({
                    address: Gen_8.address,
                    abi: Gen_8.abi,
                    functionName: "GetID_Ref",
                    args: [props.ID_]
                });
                SetSponser_ID(ref_Id);
            }
            catch(error) {
                console.log(error);
                SetSponser_ID("");
            }
        }
        Load();
    }, [props.Should, props.ID_]);

    return (
        <>
            <div className="card-single">
                {/* <!-- <div className="hide-space"></div> --> */}
                <div className="card-single-header">
                    <div>My_ID</div>                      
                    <div className="all-detail">
                        <span>{props.ID_}</span>
                    </div> 
                </div>
                <div className="card-single-header">
                    <div>Sponsor_ID</div>                      
                    <div className="all-detail">
                        <span>{Sponser_ID}</span>
                    </div> 
                </div>
            </div>
        </>
    );
}
function Income_Detail(props) {

    const [Ref_Income, SetRef_Income] = useState("0.0000");
    const [Global_Income, SetGlobal_Income] = useState("0.0000");
    const [Fix_Income, SetFix_Income] = useState("0.0000");
    const [Total_Income, SetTotal_Income] = useState("0.0000");

    useEffect(() => {
        const Load = async() => {
            try {
                SetRef_Income(Card_LC());
                SetGlobal_Income(Card_LC());
                SetFix_Income(Card_LC());
                SetTotal_Income(Card_LC());

                
                let Ref_Income_ = await client.readContract({
                    address: Gen_8_RR.address,
                    abi: Gen_8_RR.abi,
                    functionName: "GetRef_Total_Reward",
                    args: [props.ID_]
                });
                let Upid_Reward_ = await client.readContract({
                    address: Gen_8_Cal.address,
                    abi: Gen_8_Cal.abi,
                    functionName: "GetUpid_Total_Reward",
                    args: [props.ID_]
                });
                let Fix_Reward_ = await client.readContract({
                    address: Fixed_Pool.address,
                    abi: Fixed_Pool.abi,
                    functionName: "GetID_Total_Reward_Record",
                    args: [props.ID_]
                });
                let Total_Reward_ = await client.readContract({
                    address: Gen_8_RR.address,
                    abi: Gen_8_RR.abi,
                    functionName: "GetTotal_Reward",
                    args: [props.ID_]
                });
                

                SetRef_Income(Is_Value_Format(Ref_Income_));
                SetGlobal_Income(Is_Value_Format(Upid_Reward_));
                SetFix_Income(Is_Value_Format(Fix_Reward_));
                SetTotal_Income(Is_Value_Format(Total_Reward_));
            }
            catch(error) {
                console.log(error);
                SetRef_Income("0.0000");
                SetGlobal_Income("0.0000");
                SetFix_Income("0.0000");
                SetTotal_Income("0.0000");
            }
        }
        Load();
    }, [props.Should, props.ID_]);

    return (
        <>
            <div className="card-single">
                <div className="card-single-header">
                    <div>Referral Income</div>                      
                    <div className="all-detail">
                        <span>{Ref_Income}</span>
                    </div> 
                </div>
                <div className="card-single-header">
                    <div>Global level Income</div>                      
                    <div className="all-detail">
                        <span>{Global_Income}</span>
                    </div> 
                </div>
                <div className="card-single-header">
                    <div>Fix Pool Income</div>                      
                    <div className="all-detail">
                        <span>{Fix_Income}</span>
                    </div> 
                </div>
                <div className="card-single-header">
                    <div>Total Income</div>                      
                    <div className="all-detail">
                        <span>{Total_Income}</span>
                    </div> 
                </div>
            </div>
        </>
    );
}
function Team_Detail(props) {

    const [My_Direct, SetMy_Direct] = useState(0);
    const [My_Global, SetMy_Global] = useState(0);

    useEffect(() => {
        const Load = async() => {
            try {
                SetMy_Direct(Card_LC());
                SetMy_Global(Card_LC());

                let my_direct_ = await client.readContract({
                    address: Gen_8.address,
                    abi: Gen_8.abi,
                    functionName: "GetRef_Node",
                    args: [props.ID_]
                });

                let my_global_ = await client.readContract({
                    address: Gen_8.address,
                    abi: Gen_8.abi,
                    functionName: "GetUpid_Total_Team",
                    args: [props.ID_]
                });

                // console.log(my_direct_);
                // console.log(my_global_);

                SetMy_Direct(my_direct_);
                SetMy_Global(my_global_);
            }
            catch(error) {
                console.log(error);
                SetMy_Direct("0.0000");
                SetMy_Global("0.0000");
            }
        }
        Load();
    }, [props.Should, props.ID_]);

    return (
        <>
            <div className="card-single">
                <div className="card-single-header">
                    <div>MY_Direct_Team</div>                      
                    <div className="all-detail">
                        <span>{My_Direct}</span>
                    </div> 
                </div>
                <div className="card-single-header">
                    <div>MY_Global_Team</div>                      
                    <div className="all-detail">
                        <span>{My_Global}</span>
                    </div> 
                </div>
            </div> 
        </>
    );
}

//----Slots/Packages--------

export function Slots_Form(props) {
    
    const [Ref_Link, SetRef_Link] = useState();

    const [Should, SetShould] = useState(true);
        
    const Reload = async() => {
        try {
            if(Should === true) {
                SetShould(false);
            }
            else if(Should === false) {
                SetShould(true);
            }
            // console.log("Got Reloaded!.");
        }
        catch(error) {
            console.log(error);
        }
    }

    useEffect(() => {
        const Load_Ref = async() => {
            try {
            // console.log(props.ID_);
                if(props.ID_ != undefined) {
                    SetRef_Link(url + "r/" + props.ID_);
                    Reload();
                }
                else {
                    SetRef_Link(Card_LC());
                }                
            }
            catch(error) {
                console.log(error);
            }
        }
        Load_Ref();
    }, [props.ID_]);
    
    return (
        <>
            {/* <!-------Packages---Status---Card----------------------->  */}
            {/* <div className="hide-space"></div> */}
            <div className="back-grid-short">                                 
                <div className="heading">
                    <span>Packages</span>
                </div>
            </div>
            <div className="back-grid">
                <div className="cards">
                    <div className="card-single">
                        <div className="card-single-header">
                            <div>Refferal link</div>
                            <div className="r-link">
                                <span>{Ref_Link}</span>
                            </div>
                            <div className="copy-link">
                                <button className="btn" onClick={() => {Copy(Ref_Link, props.showAlert)}}>
                                    <div>Copy</div>
                                </button> 
                            </div>
                        </div>
                    </div>
                    <div className="card-check-gap-first back-grid-reload">
                        <div className="back-grid-slot-fix-pool">
                            <div className="slot-grid-reload" onClick={() => {Reload()}}><a>{"Refresh"}</a></div>
                        </div>
                    </div>
                    <Fix_Pool SetLoadingModal={props.SetLoadingModal} showAlert={props.showAlert} address={props.address} ID_={props.ID_} ID_Type_={props.ID_Type_} Should={Should} Reload={Reload}/>
                    <Packages SetLoadingModal={props.SetLoadingModal} showAlert={props.showAlert} address={props.address} ID_={props.ID_} ID_Type_={props.ID_Type_} Should={Should} Reload={Reload} Load_Main_Data={props.Load_Main_Data}/>
                </div>   
            </div>
        </>
    );
}

function Fix_Pool(props) {

    const [Remaining_Amt, SetRemaining_Amt] = useState(0);
    const [Remaining_Count, SetRemaining_Count] = useState(0);
    const [Should_Show, SetShould_Show] = useState(false);

    const Load = async() => {
        try {
            let ID_Total_Value_Received = await client.readContract({
                address: Fixed_Pool.address,
                abi: Fixed_Pool.abi,
                functionName: "GetID_Total_Value_Received",
                args: [props.ID_]
            });
            let Core_Amount = BigInt(20000000000000000000); //----20 Core   //---18-Decimals---- Means 1 CORE
            // let Core_Amount = BigInt(200000000000000000); //----0.20 Core   //---18-Decimals---- Means 1 CORE

            let count = 0;
            let minus_amt = ID_Total_Value_Received;

            if(BigInt(ID_Total_Value_Received) >= Core_Amount) {
                do {
                    if(BigInt(minus_amt) >= Core_Amount) {
                        count++;
                        minus_amt -= Core_Amount;
                        // console.log("count : " + count + " || minus_amt: " + minus_amt);
                    }
                    else {
                        break;
                    }
                }
                while(true);
                SetRemaining_Count(Number(count));
            }
            else {
                SetRemaining_Count(Number(0));
            }
            SetRemaining_Amt(Format_Core_For_Fix(ID_Total_Value_Received) + ' C');
            
            let User_Pack_No = await client.readContract({
                address: Gen_8.address,
                abi: Gen_8.abi,
                functionName: "GetUser_Pack_No",
                args: [props.ID_]
            });

            if(Number(User_Pack_No) >= Number(4) && Number(count) > Number(0)) {
                let to_cou = await client.readContract({
                    address: Gen_8_Cal.address,
                    abi: Gen_8_Cal.abi,
                    functionName: "GetFixPool_Certain_Pack_Id_Count",
                    args: [props.ID_, Number(4)]
                });
                // console.log("total dire of pack 4: " + Number(to_cou));
                let to_en = await client.readContract({
                    address: Fixed_Pool.address,
                    abi: Fixed_Pool.abi,
                    functionName: "GetID_Total_Entered",
                    args: [props.ID_]
                });
                // console.log("total time's id as entered : " + Number(to_en) + " and is going to enter now: " + Number(Number(to_en)+Number(1)));
                let should_ = false;
                if(Number(to_en) == Number(0)) {
                    should_ = true;
                }
                else if(Number(to_en) == Number(1)) {
                    should_ = false;
                    if(Number(to_cou) >= Number(1)) {
                        should_ = true;
                    }
                }            
                else if(Number(to_en) == Number(2)) {
                    should_ = false;
                    if(Number(to_cou) >= Number(2)) {
                        should_ = true;
                    }                
                }            
                else if(Number(to_en) == Number(3)) {
                    should_ = false;
                    if(Number(to_cou) >= Number(3)) {
                        should_ = true;
                    }                
                }
                else if(Number(to_en) == Number(4)) {
                    should_ = false;
                    if(Number(to_cou) >= Number(4)) {
                        should_ = true;
                    }                
                }
                else if(Number(to_en) >= Number(5)) {
                    let Num_Of_Times_Ent_Condi = [];
                    for (let sta = Number(Number(to_en)+Number(1)); sta <= Number(Number(to_en)+Number(2)); sta++) {
                        Num_Of_Times_Ent_Condi[sta] = Math.floor((sta + 4) / 2);
                    }
                    should_ = false;
                    if(Number(to_cou) >= Number(Num_Of_Times_Ent_Condi[Number(Number(to_en)+Number(1))])) {
                        should_ = true;
                    }
                }
                
                if(should_ == true) {
                    SetShould_Show(true);
                }
                else if(should_ == false) {
                    SetShould_Show(false);                    
                }               
            }
            else {
                SetShould_Show(false);
            }
        }
        catch(error) {
            console.log(error);
        }
    }

    const Activate = async() => {
        try {
            props.SetLoadingModal(true, true);
            if (window.ethereum) {
                // Delcalre a Wallet Client
                const walletClient = createWalletClient({
                    account: props.address,
                    chain: p_chain,
                    transport: custom(window.ethereum)
                });

                //console.log("WalletClient");
                //console.log(walletClient);
                
                try {
                    props.SetLoadingModal(true, false);
                    let request_writeContract = await walletClient.writeContract({
                        address: Fixed_Pool.address,
                        abi: Fixed_Pool.abi,
                        functionName: "FPool_Activate_Con",
                        args: [props.ID_],
                        
                        maxPriorityFeePerGas: BigInt(60e9), // required minimum
                        maxFeePerGas: BigInt(150e9),    
                    });
                    props.SetLoadingModal(true, true);            

                    // console.log(request_writeContract);
                    
                    const transaction = await client.waitForTransactionReceipt({confirmations: 5, hash: request_writeContract});
                    // console.log("Transaction is : ");
                    // console.log(transaction);
                    if (transaction.status === "success") {
                        let updated_to_en = await client.readContract({
                            address: Fixed_Pool.address,
                            abi: Fixed_Pool.abi,
                            functionName: "GetID_Total_Entered",
                            args: [props.ID_]
                        });
                        props.SetLoadingModal(false, false);
                        if(Number(updated_to_en) === Number(1)) {
                            props.showAlert("FixPool Entered 1 Time!...", "success", true);
                        }
                        else if(Number(updated_to_en) > Number(1)) {
                            props.showAlert("FixPool Re-Entered "+Number(updated_to_en)+" Time!...", "success", true);
                        }
                        setTimeout(() => {
                            props.Reload();
                        }, [2000]);
                    }
                    else {
                        props.SetLoadingModal(false, false); 
                        props.showAlert("Transaction Reverted!...", "danger", true);
                    }
                }
                catch {
                    props.SetLoadingModal(false, false); 
                    props.showAlert("Transaction Reverted!...", "danger", true);
                }
            }
            else {
                props.SetLoadingModal(false, false);
                props.showAlert("Please SignUp Through DAPPS!...", "warning", false);
            }
        }
        catch(error) {
            console.log(error);
            props.SetLoadingModal(false, false);
        }
    }

    // const Withdrawl_Fix = async() => {
    //     try {
    //         console.log(props.address);
    //         let FixPool_BalanceOf = await client.getBalance({address: Fixed_Pool.address});
    //         console.log(FixPool_BalanceOf);

    //         props.SetLoadingModal(true, true);
    //         if (window.ethereum) {
    //             // Delcalre a Wallet Client
    //             const walletClient = createWalletClient({
    //                 account: props.address,
    //                 chain: p_chain,
    //                 transport: custom(window.ethereum)
    //             });

    //             let Fix_Pool_Pass = "";
    //             let Creator2_Pass = "";

    //             try {
    //                 props.SetLoadingModal(true, false);
    //                 let request_writeContract = await walletClient.writeContract({
    //                     address: Fixed_Pool.address,
    //                     abi: Fixed_Pool.abi,
    //                     functionName: "Withdraw_Amt",
    //                     args: [Fix_Pool_Pass, Creator2_Pass, FixPool_BalanceOf],
    //
    //                     maxPriorityFeePerGas: BigInt(60e9), // required minimum
    //                     maxFeePerGas: BigInt(150e9),    
    //                 });
    //                 props.SetLoadingModal(true, true);            

    //                 // console.log(request_writeContract);
                    
    //                 const transaction = await client.waitForTransactionReceipt({confirmations: 5, hash: request_writeContract});
    //                 // console.log("Transaction is : ");
    //                 // console.log(transaction);
    //                 if (transaction.status === "success") {
    //                     props.SetLoadingModal(false, false);
    //                     props.showAlert("FixPool Activated!...", "success", true);
    //                     setTimeout(() => {
    //                         props.Reload();
    //                     }, [2000]);
    //                 }
    //                 else {
    //                     props.SetLoadingModal(false, false);
    //                     props.showAlert("Transaction Reverted!...", "danger", true);
    //                 }
    //             }
    //             catch {
    //                 props.SetLoadingModal(false, false); 
    //                 props.showAlert("Transaction Reverted!...", "danger", true);
    //             }
    //         }
    //         else {
    //             props.SetLoadingModal(false, false);
    //             props.showAlert("Please SignUp Through DAPPS!...", "warning", false);
    //         }
    //     }
    //     catch(error) {
    //         props.SetLoadingModal(false, false);
    //         console.log(error);
    //     }
    // }

    useEffect(() => {
        Load();
    }, [props.Should, props.ID_, props.address]);

    return (
        <>
            <div className="card-check-gap-first back-grid-activation">
                <div className="slot-n">Fix Pool</div>
                <div className="back-grid-items-fix-pool">
                    <span className="slot-type"></span>
                    <span className="slot-amount">{Remaining_Amt}</span>
                    <span className="c-tikker-logo"><img src={core_1} alt=""/></span>
                </div>
                <div className="back-grid-items-fix-pool">
                    <span className="slot-type"></span>
                    <span className="slot-amount">{Remaining_Count}</span>
                    <span className="c-tikker-logo"><img src={core_1} alt=""/></span>
                </div>         
                <div className="back-grid-slot-fix-pool">
                    {
                        Should_Show === true ? (
                            <div className="slot-activation" onClick={() => {Activate()}}><a>ACTIVATE</a></div>
                        ) : (
                            <></>
                        )
                    }
                </div>           

                {/* <div className="back-grid-slot-fix-pool">
                    <div className="slot-activation" onClick={() => {Withdrawl_Fix()}}><a>Withdrawl_Fix</a></div>
                </div> */}
            </div>
        </>
    )
}

function IsAct_Form(props) {
    useEffect(() => {
        // console.log(props.IsActivated + " +||+ " + Number(props.PackNum) + " +||+ " + props.IsEligible);
    }, []);
    return (
        <>
            {
                props.IsActivated === true ? (
                    <>
                        {
                            props.IsEligible === true ? (
                                <>
                                    <div className="slot-activation"><a onClick={() => {props.ReTopUp_Package(Number(props.PackNum));}}>RE-TOPUP</a></div>
                                </>
                            ) : (
                                <></>
                            )
                        }
                    </>
                ) : props.IsActivated === false ? (
                    <>
                        <div className="slot-activation"><a onClick={() => {props.Activated_Package(Number(props.PackNum));}}>ACTIVATE</a></div>        
                    </>
                ) : (
                    <></>
                )
            }
        </>
    
    )
}

function Packages(props) {

    // const {address} = useAccount();

    const [Pack1_IsActivated, SetPack1_IsActivated] = useState(true);
    const [Pack2_IsActivated, SetPack2_IsActivated] = useState(true);
    const [Pack3_IsActivated, SetPack3_IsActivated] = useState(true);
    const [Pack4_IsActivated, SetPack4_IsActivated] = useState(true);
    const [Pack5_IsActivated, SetPack5_IsActivated] = useState(true);
    const [Pack6_IsActivated, SetPack6_IsActivated] = useState(true);
    const [Pack7_IsActivated, SetPack7_IsActivated] = useState(true);
    const [Pack8_IsActivated, SetPack8_IsActivated] = useState(true);

    const [Pack1_IsEligible, SetPack1_IsEligible] = useState(false);
    const [Pack2_IsEligible, SetPack2_IsEligible] = useState(false);
    const [Pack3_IsEligible, SetPack3_IsEligible] = useState(false);
    const [Pack4_IsEligible, SetPack4_IsEligible] = useState(false);
    const [Pack5_IsEligible, SetPack5_IsEligible] = useState(false);
    const [Pack6_IsEligible, SetPack6_IsEligible] = useState(false);
    const [Pack7_IsEligible, SetPack7_IsEligible] = useState(false);
    const [Pack8_IsEligible, SetPack8_IsEligible] = useState(false);

    const ReTopUp_Package = async(pack_no) => {
        try {
            if (window.ethereum) {
                props.SetLoadingModal(true, true);
                // Delcalre a Wallet Client
                const walletClient = createWalletClient({
                    account: props.address,
                    chain: p_chain,
                    transport: custom(window.ethereum)
                });

                //console.log("WalletClient");
                //console.log(walletClient);
                
                let Core_Amount = []; //----10 CORE   //---18-Decimals---- Means 1 CORE
            
                Core_Amount[Number(1)] = BigInt(40000000000000000000); //----40 CORE   //---18-Decimals---- Means 1 CORE
                // Core_Amount[Number(1)] = BigInt(400000000000000000); //----0.40 CORE   //---18-Decimals---- Means 1 CORE
                
                if(Number(pack_no) > Number(1)) {
                    for(let c = 2; c <= Number(pack_no); c++) {
                        Core_Amount[Number(c)] = BigInt(Core_Amount[Number(c-1)] + Core_Amount[Number(1)]);
                    }
                }

                //--

                props.SetLoadingModal(true, true);
                let User_Core_BalanceOf = await client.getBalance({address: props.address});
                if(BigInt(User_Core_BalanceOf) > BigInt(Core_Amount[pack_no])) {
                    try {
                        props.SetLoadingModal(true, true);//false);
                        let request_writeContract = await walletClient.writeContract({
                            address: Gen_8.address,
                            abi: Gen_8.abi,
                            functionName: "ReTopUp",
                            args: [props.ID_, pack_no],
                            value: BigInt(Core_Amount[pack_no]),
                            
                            maxPriorityFeePerGas: BigInt(60e9), // required minimum
                            maxFeePerGas: BigInt(150e9),       
                        });
                        props.SetLoadingModal(true, true);            
        
                        // console.log(request_writeContract);
                        
                        const transaction = await client.waitForTransactionReceipt({confirmations: 5, hash: request_writeContract});
                        // console.log("Transaction is : ");
                        // console.log(transaction);
                        if (transaction.status === "success") {
                            props.SetLoadingModal(false, false);
                            props.showAlert("Package " + pack_no + " ReTopUped!...", "success", true);
                            setTimeout(() => {
                                props.Reload();
                                props.Load_Main_Data();
                            }, [2000]);
                        }
                        else {
                            props.SetLoadingModal(false, false);
                            props.showAlert("Transaction Reverted!...", "danger", true);
                        }
                    }
                    catch {
                        props.SetLoadingModal(false, false); 
                        props.showAlert("Transaction Reverted!...", "danger", true);
                    }
                }
                else {
                    props.SetLoadingModal(false, false);
                    props.showAlert("Insufficient Balance!...", "danger", true);
                }
            }
            else {
                props.SetLoadingModal(false, false);
                props.showAlert("Please SignUp Through DAPPS!...", "warning", false);
            }
        }
        catch(error) {
            console.log(error);
            props.SetLoadingModal(false, false);
        }
    }
    const Activated_Package = async(pack_no) => {
        try {
            if (window.ethereum) {
                props.SetLoadingModal(true, true);
                // Delcalre a Wallet Client
                const walletClient = createWalletClient({
                    account: props.address,
                    chain: p_chain,
                    transport: custom(window.ethereum)
                });

                //console.log("WalletClient");
                //console.log(walletClient);
                
                let Core_Amount = []; //----10 CORE   //---18-Decimals---- Means 1 CORE
            
                Core_Amount[Number(1)] = BigInt(40000000000000000000); //----40 Core   //---18-Decimals---- Means 1 CORE
                // Core_Amount[Number(1)] = BigInt(400000000000000000); //----0.40 Core   //---18-Decimals---- Means 1 CORE

                if(Number(pack_no) > Number(1)) {
                    for(let c = 2; c <= Number(pack_no); c++) {
                        Core_Amount[Number(c)] = BigInt(Core_Amount[Number(c-1)] + Core_Amount[Number(1)]);
                    }
                }

                //--
                props.SetLoadingModal(true, true);
                let User_Core_BalanceOf = await client.getBalance({address: props.address});
                
                if(BigInt(User_Core_BalanceOf) > BigInt(Core_Amount[pack_no])) {
                    try {
                        props.SetLoadingModal(true, true);//false);
                        let request_writeContract = await walletClient.writeContract({
                            address: Gen_8.address,
                            abi: Gen_8.abi,
                            functionName: "Activate",
                            args: [props.ID_],
                            value: BigInt(Core_Amount[pack_no]),
                            
                            // // 👇 force legacy tx
                            // gasPrice: BigInt(60e9) // 60 gwei (minimum required on Core)      
                            
                            maxPriorityFeePerGas: BigInt(60e9), // required minimum
                            maxFeePerGas: BigInt(150e9),
                        });
                        props.SetLoadingModal(true, true);            
        
                        // console.log(request_writeContract);
                        
                        const transaction = await client.waitForTransactionReceipt({confirmations: 5, hash: request_writeContract});
                        // console.log("Transaction is : ");
                        // console.log(transaction);
                        if (transaction.status === "success") {
                            props.SetLoadingModal(false, false);
                            props.showAlert("Package " + pack_no + " Activated!...", "success", true);
                            setTimeout(() => {
                                props.Reload();
                                props.Load_Main_Data();
                            }, [2000]);
                        }
                        else {
                            props.SetLoadingModal(false, false);
                            props.showAlert("Transaction Reverted!...", "danger", true);
                        }
                    }
                    catch {
                        props.SetLoadingModal(false, false); 
                        props.showAlert("Transaction Reverted!...", "danger", true);
                    }
                }
                else {
                    props.SetLoadingModal(false, false);
                    props.showAlert("Insufficient Balance!...", "danger", true);
                }
            }
            else {
                props.SetLoadingModal(false, false);
                props.showAlert("Please SignUp Through DAPPS!...", "warning", false);
            }
        }
        catch(error) {
            console.log(error);
            props.SetLoadingModal(false, false);
        }
    }

    const Load_Arr = async(pack_no) => {
        try {

            let Core_Amount = []; //----40 CORE   //---18-Decimals---- Means 1 CORE
            
            Core_Amount[Number(1)] = 40; //----40 CORE   //---18-Decimals---- Means 1 CORE

            // console.log("Core_Amount[1]: " + Core_Amount[Number(1)]);
            if(Number(pack_no) > Number(1)) {
                for(let c = 2; c <= Number(pack_no); c++) {
                    Core_Amount[Number(c)] = (Core_Amount[Number(c-1)] + Core_Amount[Number(1)]);
                    // console.log("Core_Amount["+Number(c)+"]: " + Core_Amount[Number(c)]);
                }
            }

            SetPack1_IsActivated(true);
            SetPack1_IsEligible(false);
    
            SetPack2_IsActivated(true);
            SetPack2_IsEligible(false);
            
            SetPack3_IsActivated(true);
            SetPack3_IsEligible(false);
            
            SetPack4_IsActivated(true);
            SetPack4_IsEligible(false);
            
            SetPack5_IsActivated(true);
            SetPack5_IsEligible(false);
            
            SetPack6_IsActivated(true);
            SetPack6_IsEligible(false);
            
            SetPack7_IsActivated(true);
            SetPack7_IsEligible(false);
            
            SetPack8_IsActivated(true);
            SetPack8_IsEligible(false);
            
            const Arr = [];
            Arr.push({
                IsActivated: false//true
            });
            let oneis = false
            for(let i = 1; i <= Number(8); i++) {
    
                let User_Pack_No_Exist = await client.readContract({
                    address: Gen_8.address,
                    abi: Gen_8.abi,
                    functionName: "GetUser_Pack_No_Exist",
                    args: [props.ID_, Number(i)]
                });
    
                if(User_Pack_No_Exist === true) {

                    let User_Pack_No_Is_Eligible = await client.readContract({
                        address: Gen_8_Cal.address,
                        abi: Gen_8_Cal.abi,
                        functionName: "GetUser_Pack_No_Is_Eligible",
                        args: [props.ID_, Number(i)]
                    });

                    let eligible_to_retopup = false;
                    if(User_Pack_No_Is_Eligible === false) {
                        eligible_to_retopup = true;
                    }
                    else if(User_Pack_No_Is_Eligible === true) {
                        eligible_to_retopup = false;
                    }
                    Arr.push({
                        IsActivated: true,
                        Is_Eligible: eligible_to_retopup,
                        pack: Number(i),
                        amount: Core_Amount[i]
                    });
                }
                else if(User_Pack_No_Exist === false) {
                    let isAct;
                    if(Number(i-1) === Number(0)) {
                        isAct = false;
                    }
                    else {
                        isAct = false;
                        // console.log((i-1) + " " + Arr[(i-1)].IsActivated);
                        if(oneis === false) {
                            if(Arr[(i-1)].IsActivated === false) {
                                isAct = true;
                                oneis = true
                            }
                        }
                        else if(oneis === true) {
                            isAct = true;
                        }    
                    }
                    
                    Arr.push({
                        IsActivated: isAct,
                        Is_Eligible: false,
                        pack: Number(i),
                        amount: Core_Amount[i]
                    });

                    for(let rest = (i+1); rest <= Number(15); rest++) {
                          Arr.push({
                            IsActivated: true,
                            Is_Eligible: false,
                            pack: Number(rest),
                            amount: Core_Amount[rest]
                        });  
                    }
                    break;
                }
            }
    
            // console.log(Arr);
            
            SetPack1_IsActivated(Arr[1].IsActivated);
            SetPack1_IsEligible(Arr[1].Is_Eligible);
    
            SetPack2_IsActivated(Arr[2].IsActivated);
            SetPack2_IsEligible(Arr[2].Is_Eligible);
    
            SetPack3_IsActivated(Arr[3].IsActivated);
            SetPack3_IsEligible(Arr[3].Is_Eligible);
        
            SetPack4_IsActivated(Arr[4].IsActivated);
            SetPack4_IsEligible(Arr[4].Is_Eligible);
            
            SetPack5_IsActivated(Arr[5].IsActivated);
            SetPack5_IsEligible(Arr[5].Is_Eligible);
            
            SetPack6_IsActivated(Arr[6].IsActivated);
            SetPack6_IsEligible(Arr[6].Is_Eligible);
            
            SetPack7_IsActivated(Arr[7].IsActivated);
            SetPack7_IsEligible(Arr[7].Is_Eligible);
            
            SetPack8_IsActivated(Arr[8].IsActivated);
            SetPack8_IsEligible(Arr[8].Is_Eligible);

            // console.log("Pack2_IsActivated: " + Pack2_IsActivated | " Pack2_IsEligible: " + Pack2_IsEligible)
            // console.log("Pack3_IsActivated: " + Pack3_IsActivated | " Pack3_IsEligible: " + Pack3_IsEligible)
            // console.log("Pack4_IsActivated: " + Pack4_IsActivated | " Pack4_IsEligible: " + Pack4_IsEligible)
        }
        catch(error) {
            console.log(error);
        }
    }

    const Load = async() => {
        try {
            if(props.ID_Type_ === true) {
                let User_Pack_No = await client.readContract({
                    address: Gen_8.address,
                    abi: Gen_8.abi,
                    functionName: "GetUser_Pack_No",
                    args: [props.ID_]
                });
                Load_Arr(Number(Number(User_Pack_No) + Number(1)));
            }
            else if(props.ID_Type_ === false) {
                Load_Arr(Number(4));
            }
        }
        catch(error) {
            console.log(error);
        }
    }

    // useEffect(() => {
    //     if(props.ID_ != undefined) {
    //         setTimeout(() => {
    //             console.log(" ");
    //             console.log("After timeout Reloaded!.");
    //             props.Reload();
    //         }, [4000]);
    //     }
    // }, [props.ID_]);
    
    useEffect(() => {
        // console.log("Package ID: " + props.ID_ + " address: " + props.address + " Should: " + props.Should);
        // Load();
        if(props.ID_) {
            Load();
        }
    }, [props.Should, props.ID_, props.address]);


    return (
        <>
            
            <div className="card-check-gap-first back-grid-activation">
                <div className="slot-n">Rank 1</div>
                <div className="back-grid-items">
                    <span className="slot-type"></span>
                    <span className="slot-amount">40</span>
                    <span className="c-tikker-logo"><img src={core_1} alt=""/></span>
                </div>         
                <div className="back-grid-slot">
                    {/* <div clasName="slot-activation"><a>ACTIVATE</a></div> */}
                    <IsAct_Form IsActivated={Pack1_IsActivated} Activated_Package={Activated_Package} ReTopUp_Package={ReTopUp_Package} IsEligible={Pack1_IsEligible} PackNum={Number(1)}/>
                </div>              
            </div>
            <div className="card-check-gap-middle back-grid-activation">
                <div className="slot-n">Rank 2</div>
                <div className="back-grid-items">
                    <span className="slot-type"></span>
                    <span className="slot-amount">80</span>
                    <span className="c-tikker-logo"><img src={core_1} alt=""/></span>
                </div>         
                <div className="back-grid-slot">
                    {/* <div className="slot-activation" onClick={() => {Activated_Package(Number(2));}}><a>ACTIVATE</a></div> */}
                    <IsAct_Form IsActivated={Pack2_IsActivated} Activated_Package={Activated_Package} ReTopUp_Package={ReTopUp_Package} IsEligible={Pack2_IsEligible} PackNum={Number(2)}/>
                </div>              
            </div>
            <div className="card-check-gap-middle back-grid-activation">
                <div className="slot-n">Rank 3</div>
                <div className="back-grid-items">
                    <span className="slot-type"></span>
                    <span className="slot-amount">120</span>
                    <span className="c-tikker-logo"><img src={core_1} alt=""/></span>
                </div>         
                <div className="back-grid-slot">
                    {/* <div className="slot-activation"><a>ACTIVATE</a></div> */}
                    <IsAct_Form IsActivated={Pack3_IsActivated} Activated_Package={Activated_Package} ReTopUp_Package={ReTopUp_Package} IsEligible={Pack3_IsEligible} PackNum={Number(3)}/>
                </div>              
            </div>
            <div className="card-check-gap-middle back-grid-activation">
                <div className="slot-n">Rank 4</div>
                <div className="back-grid-items">
                    <span className="slot-type"></span>
                    <span className="slot-amount">160</span>
                    <span className="c-tikker-logo"><img src={core_1} alt=""/></span>
                </div>         
                <div className="back-grid-slot">
                    {/* <div className="slot-activation"><a>ACTIVATE</a></div> */}
                    <IsAct_Form IsActivated={Pack4_IsActivated} Activated_Package={Activated_Package} ReTopUp_Package={ReTopUp_Package} IsEligible={Pack4_IsEligible} PackNum={Number(4)}/>
                </div>              
            </div>
            
            <div className="card-check-gap-middle back-grid-activation">
                <div className="slot-n">Rank 5</div>
                <div className="back-grid-items">
                    <span className="slot-type"></span>
                    <span className="slot-amount">200</span>
                    <span className="c-tikker-logo"><img src={core_1} alt=""/></span>
                </div>         
                <div className="back-grid-slot">
                    {/* <div className="slot-activation"><a>ACTIVATE</a></div> */}
                    <IsAct_Form IsActivated={Pack5_IsActivated} Activated_Package={Activated_Package} ReTopUp_Package={ReTopUp_Package} IsEligible={Pack5_IsEligible} PackNum={Number(5)}/>
                </div>              
            </div>
            <div className="card-check-gap-middle back-grid-activation">
                <div className="slot-n">Rank 6</div>
                <div className="back-grid-items">
                    <span className="slot-type"></span>
                    <span className="slot-amount">240</span>
                    <span className="c-tikker-logo"><img src={core_1} alt=""/></span>
                </div>         
                <div className="back-grid-slot">
                    {/* <div className="slot-activation"><a>ACTIVATE</a></div> */}
                    <IsAct_Form IsActivated={Pack6_IsActivated} Activated_Package={Activated_Package} ReTopUp_Package={ReTopUp_Package} IsEligible={Pack6_IsEligible} PackNum={Number(6)}/>
                </div>              
            </div>
            <div className="card-check-gap-middle back-grid-activation">
                <div className="slot-n">Rank 7</div>
                <div className="back-grid-items">
                    <span className="slot-type"></span>
                    <span className="slot-amount">280</span>
                    <span className="c-tikker-logo"><img src={core_1} alt=""/></span>
                </div>         
                <div className="back-grid-slot">
                    {/* <div className="slot-activation"><a>ACTIVATE</a></div> */}
                    <IsAct_Form IsActivated={Pack7_IsActivated} Activated_Package={Activated_Package} ReTopUp_Package={ReTopUp_Package} IsEligible={Pack7_IsEligible} PackNum={Number(7)}/>
                </div>              
            </div>
            <div className="card-check-gap-middle back-grid-activation">
                <div className="slot-n">Rank 8</div>
                <div className="back-grid-items">
                    <span className="slot-type"></span>
                    <span className="slot-amount">320</span>
                    <span className="c-tikker-logo"><img src={core_1} alt=""/></span>
                </div>         
                <div className="back-grid-slot">
                    {/* <div className="slot-activation"><a>ACTIVATE</a></div> */}
                    <IsAct_Form IsActivated={Pack8_IsActivated} Activated_Package={Activated_Package} ReTopUp_Package={ReTopUp_Package} IsEligible={Pack8_IsEligible} PackNum={Number(8)}/>
                </div>              
            </div>
            <div className="card-check-gap-last"></div>
        </>
    )
}

{/*----Slots/Packages--------*/}

export function Rank_Income_Form(props) {

    const [Pack_Is, SetPack_Is] = useState("");
    const [Pack_List, SetPack_List] = useState([]);
    
    useEffect(() => { 
        const Load = async() => {
            try {
                SetPack_Is(Loading_Component());
                SetPack_List([]);

                let User_Pack_No;

                if(props.ID_Type_ === true) {
                    User_Pack_No = await client.readContract({
                        address: Gen_8.address,
                        abi: Gen_8.abi,
                        functionName: "GetUser_Pack_No",
                        args: [props.ID_]
                    });

                    // console.log("User_Pack_No: " + Number(User_Pack_No));
                }
                else if(props.ID_Type_ === false) {
                    User_Pack_No = Number(8);
                }
                // console.log(User_Pack_No);

                const Arr = [];
                for(let i = 1; i <= Number(User_Pack_No); i++) {
                    
                    let Total_Pack_Reward = await client.readContract({
                        address: Gen_8_RR.address,
                        abi: Gen_8_RR.abi,
                        functionName: "GetTotal_Pack_Reward",
                        args: [props.ID_, Number(i)]
                    });
                    Arr.push({
                        sr: i,
                        rank: "Rank " + i,
                        income: (Is_Value_Format_Without_Symbol(Total_Pack_Reward))
                    });
                }
                SetPack_List(Arr);
                SetPack_Is("");
            }
            catch(error) {
                console.log(error);
                SetPack_Is("");
                SetPack_List([]);
            }
        }
        
        if(props.ID_) {
            Load();
        }
    }, [props.ID_]);

    return (
        <>  
            {/* <!-------Rank----Income------------------------>      */}
            {/* <div className="hide-space"></div> */}
            <div className="back-grid-short">                                 
                <div className="heading">
                    <span>Rank Income</span>
                        {/* <!-- <div className="card-next-previous">
                        <span><button className="click-level">Prev</button></span>
                        <span>20/100</span>
                        <span><button className="click-level">Next</button></span>
                    </div> --> */}
                </div>
            </div>
            <div className="back-grid">
                <div className="table scroll-bar">
                    <table>
                        <thead>
                            <tr>
                                <td>Sr</td>
                                <td>Rank</td>
                                <td>Income</td>
                                <td>Tikker</td>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                Pack_Is === "" ? (
                                    <>
                                        {
                                            Pack_List.map((data) => {
                                                return (
                                                    <tr key={data.sr}>
                                                        <td>{data.sr}</td>
                                                        <td>{data.rank}</td>
                                                        <td>{data.income}</td>
                                                        <td>CORE</td>
                                                    </tr> 
                                                );
                                            })
                                        }
                                    </>
                                ) : (
                                    <>
                                        <tr>
                                            <td></td>
                                            <td>{Pack_Is}</td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    </>
                                )
                            }
                        </tbody>
                    </table>
                </div> 
            </div>
        </>
    );
}

//----Refferal--------

export function Refferal_Income_Form(props) {

    let Selected_Pack = Number(0);

    const [Total_Pack, SetTotal_Pack] = useState([]);
    const [Selected_Grid, SetSelected_Grid] = useState("FIRST");

    const [Total_Page, SetTotal_Page] = useState(Number(0));
    const [Current_Page, SetCurrent_Page] = useState(Number(0));

    const [Refferal_Is, SetRefferal_Is] = useState("");
    const [Refferal_List, SetRefferal_List] = useState([]);

    const [Refferal_Pack_Is, SetRefferal_Pack_Is] = useState("");
    const [Refferal_Pack_List, SetRefferal_Pack_List] = useState([]);

    const ID_Detail = async(ref_, id_, pack_no_, total_retopup_received_) => {
        try {

            // console.log(" ");
            // console.log("Reffer_Pack_List_IS: pack_no: " + pack_no_);
            SetRefferal_Pack_Is(Loading_Component());
            SetRefferal_Pack_List([]);

            const Arr = [];
            // console.log("ref_: " + ref_ + " id_: " + id_ + " pack_no_: " + pack_no_ + " total_retopup_received-: " + total_retopup_received_);
            for(let i = 1; i <= Number(total_retopup_received_); i++) {
                let Ref_ID_Pack_Total_Received_Count_Detail = await client.readContract({
                    address: Gen_8_Cal.address,
                    abi: Gen_8_Cal.abi,
                    functionName: "GetRef_ID_Pack_Total_Received_Count_Detail",
                    args: [ref_, id_, Number(pack_no_), Number(i)]
                });

                Arr.push({
                    sr: i,
                    id: id_,
                    topup: Number(Ref_ID_Pack_Total_Received_Count_Detail[0]),
                    rank: "R" + Number(pack_no_),
                    reward: Is_Value_Format_Without_Symbol(Ref_ID_Pack_Total_Received_Count_Detail[1]),
                    time: await Format_UTC(Number(Ref_ID_Pack_Total_Received_Count_Detail[2]))
                });
            }

            // console.log(Arr);
            SetRefferal_Pack_Is("");
            SetRefferal_Pack_List(Arr);
            // console.log(Refferal_Pack_List);
        }
        catch(error) {
            SetRefferal_Pack_Is("");
            SetRefferal_Pack_List([]);
        }
    }

    const Current_Page_Detail = async(cur_page) => {
        try {
            SetRefferal_Is(Loading_Component());

            SetRefferal_Pack_Is("");
            SetRefferal_Pack_List([]);

            let from = Number(Number(Number(cur_page) - Number(1)) * Number(20) + Number(1));
            let to = Number(Number(cur_page) * Number(20)); 
            // console.log(from + " from");
            // console.log(to + " to");

            SetRefferal_List([]);
            let Arr = [];

            for(let node = from; node <= to; node++) {
                if (Number(Selected_Pack) === Number(0)) {
                    
                    SetSelected_Grid("FIRST");
                    
                    // console.log(" ");
                    // console.log("Refferal_List: pack_no: " + Selected_Pack);

                    let Ref_Node_Count = await client.readContract({
                        address: Gen_8.address,
                        abi: Gen_8.abi,
                        functionName: "GetRef_Node_Count",
                        args: [props.ID_, Number(node)]
                    });
                    // console.log(node);
                    // console.log(Ref_Node_Count);
    
                    if(Ref_Node_Count !== "") {
                        // console.log("Is Not Break");

                        let ID_Add = await client.readContract({
                            address: Gen_8.address,
                            abi: Gen_8.abi,
                            functionName: "GetID_Add",
                            args: [Ref_Node_Count]
                        });
                        // console.log(ID_Add);

                        let User_Pack_No = await client.readContract({
                            address: Gen_8.address,
                            abi: Gen_8.abi,
                            functionName: "GetUser_Pack_No",
                            args: [Ref_Node_Count]
                        });     
    
                        let team_ = await client.readContract({
                            address: Gen_8.address,
                            abi: Gen_8.abi,
                            functionName: "GetRef_Node",
                            args: [Ref_Node_Count]
                        });  
                        
                        let TimeStamp = await client.readContract({
                            address: Gen_8.address,
                            abi: Gen_8.abi,
                            functionName: "GetUser_Pack_No_Activation_TimeStamp",
                            args: [Ref_Node_Count, Number(1)]
                        });

    
                        Arr.push({
                            sr: node,
                            id: Ref_Node_Count,
                            add: Sub_Variable(ID_Add),
                            rank: "R" + Number(User_Pack_No),
                            team: Number(team_),
                            time: await Format_UTC(Number(TimeStamp))
                        });
                    }
                    else {
                        // console.log("Is Break");
                        break;
                    }

                    SetSelected_Grid("FIRST");
                    
                }
                else if (Number(Selected_Pack) > Number(0)) {

                    SetSelected_Grid("SECOND");
                    // console.log(" ");
                    // console.log("Refferal_List: pack_no: " + Selected_Pack);

                    let Ref_Pack_Count_ID_And_Reward_Type = await client.readContract({
                        address: Gen_8_Cal.address,
                        abi: Gen_8_Cal.abi,
                        functionName: "GetRef_Pack_Count_ID_And_Reward_Type",
                        args: [props.ID_, Number(Selected_Pack), Number(node)]
                    });
                    // console.log(node);
                    // console.log(Ref_Pack_Count_ID_And_Reward_Type);
    
                    if(Ref_Pack_Count_ID_And_Reward_Type[0] !== "") {
                        // console.log("Is Not Break");
                        let ID_Add = await client.readContract({
                            address: Gen_8.address,
                            abi: Gen_8.abi,
                            functionName: "GetID_Add",
                            args: [Ref_Pack_Count_ID_And_Reward_Type[0]]
                        });
                        
                        let Ref_ID_Pack_Total_Reward_And_Total_Received_Count = await client.readContract({
                            address: Gen_8_Cal.address,
                            abi: Gen_8_Cal.abi,
                            functionName: "GetRef_ID_Pack_Total_Reward_And_Total_Received_Count",
                            args: [props.ID_, Ref_Pack_Count_ID_And_Reward_Type[0], Number(Selected_Pack)]
                        });
    
                        Arr.push({
                            sr: node,
                            id: Ref_Pack_Count_ID_And_Reward_Type[0],
                            add: Sub_Variable(ID_Add),
                            rank: Selected_Pack,
                            total_reward: Is_Value_Format_Without_Symbol(Ref_ID_Pack_Total_Reward_And_Total_Received_Count[0]),
                            total_retopup_received: Number(Ref_ID_Pack_Total_Reward_And_Total_Received_Count[1]),
                            reward_type: Ref_Pack_Count_ID_And_Reward_Type[1]
                        });
                    }
                    else {
                        // console.log("Is Break");
                        break;
                    }
                    
                    SetSelected_Grid("SECOND");
                }          
            }  
            
            // console.log(Arr);
            // console.log(Refferal_List);

            SetRefferal_List(Arr);
            SetRefferal_Is("");
            // console.log(Refferal_List);
        }
        catch(error) {
            console.log(error);
            SetRefferal_List([]);
            SetRefferal_Is("");
        }
    }

    const Next = async() => {
        let nextpage = Number(Number(Current_Page) + Number(1));
        if(Number(nextpage) > Number(Total_Page)) {

        }
        else if(Number(nextpage) <= Number(Total_Page)) {
            SetCurrent_Page(nextpage);
            Current_Page_Detail(nextpage);
        }
    }
    const Pre = async() => {
        let prepage = Number(Number(Current_Page) - Number(1));
        if(Number(prepage) < Number(1)) {

        }
        else if(Number(prepage) >= Number(1)) {
            SetCurrent_Page(prepage);
            Current_Page_Detail(prepage);
        }
    }

    const Select_Pack = async(Pack_No) => {
        try {
            if (Number(Pack_No) === Number(0)) {
                
                SetSelected_Grid("FIRST");
                let Ref_Node = await client.readContract({
                    address: Gen_8.address,
                    abi: Gen_8.abi,
                    functionName: "GetRef_Node",
                    args: [props.ID_]
                });

                // console.log("Ref_Node : " + Ref_Node);

                let cur_page = await Return_Page_Settings(Number(Ref_Node));
                // console.log(Number(cur_page));

                Selected_Pack = Number(Pack_No);
                // console.log("Selected_Pack : " + Number(Selected_Pack));

                SetTotal_Page(Number(cur_page));
                SetCurrent_Page(Number(cur_page));
                Current_Page_Detail(Number(cur_page));
            }
            else if (Number(Pack_No) > Number(0)) {
                
                SetSelected_Grid("SECOND");

                let Ref_Pack_Count = await client.readContract({
                    address: Gen_8_Cal.address,
                    abi: Gen_8_Cal.abi,
                    functionName: "GetRef_Pack_Count",
                    args: [props.ID_, Number(Pack_No)]
                });

                // console.log("Ref_Pack_Count " + Pack_No + " : " + Ref_Pack_Count);

                let cur_page = await Return_Page_Settings(Number(Ref_Pack_Count));
                // console.log(Number(cur_page));
                
                Selected_Pack = Number(Pack_No);
                // console.log("Selected_Pack : " + Number(Selected_Pack));

                SetTotal_Page(Number(cur_page));
                SetCurrent_Page(Number(cur_page));
                Current_Page_Detail(Number(cur_page));
                
            }
        }
        catch (error) {
            console.log(error);
            SetTotal_Page(Number(0));
            SetCurrent_Page(Number(0));
            Current_Page_Detail(0);
        }
        
    }

    useEffect(() => {
        const First_Load = async() => {
            
            let Num = 15;

            let Arr = [];
            for(let i = 1; i <= Number(Num); i++) {
                Arr.push({
                    pack: Number(i)
                });
            }
            SetTotal_Pack(Arr);

            Select_Pack(Number(0));            
        }
        
        if(props.ID_) {
            First_Load();
        }
    }, [props.ID_]);


    return (
        <>
            {/* <!--------Direct---Refrttal----Section----------------------->                 */}
            {/* <div className="hide-space"></div> */}
            <div className="back-grid-short">                                 
                <div className="heading">
                    <span>Direct Refferals</span> 
                </div>
            </div>
            <div className="back-grid-short scroll-bar">
                <div className="check-level">
                    <span><button className="click-level" onClick={() => {Select_Pack(Number(0));}}>All</button></span>
                    <span><button className="click-level" onClick={() => {Select_Pack(Number(1));}}>Rank 1</button></span>
                    <span><button className="click-level" onClick={() => {Select_Pack(Number(2));}}>Rank 2</button></span>
                    <span><button className="click-level" onClick={() => {Select_Pack(Number(3));}}>Rank 3</button></span>
                    <span><button className="click-level" onClick={() => {Select_Pack(Number(4));}}>Rank 4</button></span>
                    <span><button className="click-level" onClick={() => {Select_Pack(Number(5));}}>Rank 5</button></span>
                    <span><button className="click-level" onClick={() => {Select_Pack(Number(6));}}>Rank 6</button></span>
                    <span><button className="click-level" onClick={() => {Select_Pack(Number(7));}}>Rank 7</button></span>
                    <span><button className="click-level" onClick={() => {Select_Pack(Number(8));}}>Rank 8</button></span>
                </div>    
            </div>
            <div className="back-grid-short">                                 
                <div className="heading">
                    <div className="card-next-previous">
                        <span><button className="click-level" onClick={() => {Pre();}}>Prev</button></span>
                        <span>{Current_Page} / {Total_Page}</span>
                        <span><button className="click-level" onClick={() => {Next();}}>Next</button></span>
                    </div>
                </div>
            </div>
            {
                Selected_Grid === "FIRST" ? (
                    <>
                        <div className="back-grid">
                            <div className="table scroll-bar">                       
                                <table>
                                    <thead>
                                        <tr key={"Ref_1"}>
                                            <td>Sr</td>
                                            <td>ID</td>
                                            <td>Address</td>
                                            <td>Rank</td>
                                            <td>Team</td>
                                            <td>Time</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            Refferal_Is === "" ? (
                                                <>
                                                    {
                                                        Refferal_List.map((data) => {
                                                            // console.log(data);
                                                            return (
                                                                <>
                                                                    <tr key={data.id}>
                                                                        <td>{data.sr}</td>
                                                                        <td>{data.id}</td>
                                                                        <td>{data.add}</td>
                                                                        <td>{data.rank}</td> 
                                                                        <td>{data.team}</td>
                                                                        <td>{data.time}</td>
                                                                    </tr> 
                                                                </>
                                                            );
                                                        })
                                                    }
                                                </>
                                            ) : (
                                                <>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td>{Refferal_Is}</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr> 
                                                </>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div> 
                        </div>
                    </>  
                ) : Selected_Grid === "SECOND" ? (
                    <>
                        <div className="back-grid">
                            <div className="table scroll-bar">                       
                                <table>
                                    <thead>
                                        <tr key={"Ref_2"}>
                                            <td>Sr</td>
                                            <td>ID</td>
                                            <td>Address</td>
                                            <td>Rank</td>
                                            <td>TopUp</td>
                                            <td>Income</td>
                                            <td>Tikker</td>
                                            <td>Type</td>
                                            <td>Detail</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            Refferal_Is === "" ? (
                                                <>  
                                                    {
                                                        Refferal_List.map((data) => {
                                                            // console.log(data);
                                                            return (
                                                            <>
                                                                <tr key={data.id}>
                                                                    <td>{data.sr}</td>
                                                                    <td>{data.id}</td>
                                                                    <td>{data.add}</td>
                                                                    <td>{data.rank}</td>
                                                                    <td>{data.total_retopup_received}</td>
                                                                    <td>{data.total_reward}</td>
                                                                    <td>CORE</td>
                                                                    <td>Reffer</td>
                                                                    <td><div onClick={() => {ID_Detail(props.ID_, data.id, data.rank, data.total_retopup_received)}}>
                                                                        <a className="claim">Detail</a>
                                                                    </div></td>
                                                                </tr>
                                                            </>);
                                                        })
                                                    }
                                                </>
                                            ) : (
                                                <>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td>{Refferal_Is}</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div> 
                        </div>

                        <div className="back-grid">  
                            <div className="table scroll-bar">
                                <table>                                                                                                                                                                                      
                                    <thead>
                                        <tr key={"Ref_3"}>
                                            <td>Sr</td>
                                            <td>ID</td>
                                            <td>Rank</td>
                                            <td>TopUp</td>
                                            <td>Income</td>
                                            <td>Tikker</td>
                                            <td>TIME</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            Refferal_Pack_Is === "" ? (
                                                <>
                                                    {
                                                        Refferal_Pack_List.map((data) => {
                                                            // console.log(data);
                                                            return (
                                                                <>
                                                                    <tr key={data.id}>
                                                                        <td>{data.sr}</td>
                                                                        <td>{data.id}</td>
                                                                        <td>{data.rank}</td>
                                                                        <td>{data.topup}</td>
                                                                        <td>{data.reward}</td>
                                                                        <td>CORE</td>
                                                                        <td>{data.time}</td>
                                                                    </tr>
                                                                </>
                                                            );
                                                        })
                                                    }
                                                </>
                                            ) : (
                                                <>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td>{Refferal_Pack_Is}</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div> 
                        </div>
                    </>
                ) : (
                    <></>
                )
            }
        </>
    );
}

//----Matrix--------

export function Matrix_Income_Form(props) {

    const [Current_Pack, SetCurrent_Pack] = useState(Number(0));
    const [Total_Page, SetTotal_Page] = useState(Number(0));
    const [Current_Page, SetCurrent_Page] = useState(Number(0));

    const [Level_Downline_Is, SetLevel_Downline_Is] = useState("");
    const [Level_Downline_Detail, SetLevel_Downline_Detail] = useState([]);

    const [Level_Downline_ID_Is, SetLevel_Downline_ID_Is] = useState("");
    const [Level_Downline_ID_Detail, SetLevel_Downline_ID_Detail] = useState([]);


    const ID_Detail = async(upid_, id_, pack_no_, total_retopup_received_) => {
        try {
            SetLevel_Downline_ID_Is(Loading_Component());
            SetLevel_Downline_ID_Detail([]);

            const Arr = [];

            for(let i = 1; i <= Number(total_retopup_received_); i++) {
                let Upid_ID_Pack_Total_Received_Count_Detail = await client.readContract({
                    address: Gen_8_Cal.address,
                    abi: Gen_8_Cal.abi,
                    functionName: "GetUpid_ID_Pack_Total_Received_Count_Detail",
                    args: [upid_, id_, Number(pack_no_), Number(i)]
                });

                Arr.push({
                    sr: i,
                    id: id_,
                    topup: Number(Upid_ID_Pack_Total_Received_Count_Detail[0]),
                    rank: "R" + Number(pack_no_),
                    reward: Is_Value_Format_Without_Symbol(Upid_ID_Pack_Total_Received_Count_Detail[1]),
                    time: await Format_UTC(Number(Upid_ID_Pack_Total_Received_Count_Detail[2]))
                });
            }

            SetLevel_Downline_ID_Is("");
            SetLevel_Downline_ID_Detail(Arr);
        }
        catch(error) {
            SetLevel_Downline_ID_Is("");
            SetLevel_Downline_ID_Detail([]);
        }
    }

    const First_Load_Pack = async(pack) => {
        try {
            SetLevel_Downline_Is(Loading_Component());
            SetCurrent_Pack(Number(pack));
            let Upid_Pack_Count = await client.readContract({
                address: Gen_8_Cal.address,
                abi: Gen_8_Cal.abi,
                functionName: "GetUpid_Pack_Count",
                args: [props.ID_, Number(pack)]
            });

            let cur_page = await Return_Page_Settings(Number(Upid_Pack_Count));
            //console.log(Number(cur_page));

            SetTotal_Page(Number(cur_page));
            SetCurrent_Page(Number(cur_page));
            Current_Page_Detail(Number(cur_page), Number(pack));
        }
        catch(error) {
            console.log(error);
            SetTotal_Page(Number(0));
            SetCurrent_Page(Number(0));
            Current_Page_Detail(Number(0));
            SetLevel_Downline_Is("");
        }
    }
    const Select_Pack = async(pack) => {
        SetCurrent_Pack(pack);
        First_Load_Pack(pack);
    }
    const Current_Page_Detail = async(cur_page, cur_pack) => {
        try {
            SetLevel_Downline_Is(Loading_Component());
            SetLevel_Downline_ID_Detail([]);
            SetLevel_Downline_ID_Is("");

            let from = Number(Number(Number(cur_page) - Number(1)) * Number(20) + Number(1));
            let to = Number(Number(cur_page) * Number(20)); 
            //console.log(from + " from");
            //console.log(to + " to");

            SetLevel_Downline_Detail([]);
            let Arr = [];
            for(let i = from; i <= to; i++) {

                let Upid_Pack_Count_ID_And_ID_Reward_Type = await client.readContract({
                    address: Gen_8_Cal.address,
                    abi: Gen_8_Cal.abi,
                    functionName: "GetUpid_Pack_Count_ID_And_ID_Reward_Type",
                    args: [props.ID_, Number(cur_pack), Number(i)]
                });

                // console.log("Upid_Pack_Count_ID_And_ID_Reward_Type[0] : " + Upid_Pack_Count_ID_And_ID_Reward_Type[0]);
                if(Upid_Pack_Count_ID_And_ID_Reward_Type[0] !== "") {

                    let Upid_ID_Pack_Total_Reward_And_Total_Received_Count = await client.readContract({
                        address: Gen_8_Cal.address,
                        abi: Gen_8_Cal.abi,
                        functionName: "GetUpid_ID_Pack_Total_Reward_And_Total_Received_Count",
                        args: [props.ID_, Upid_Pack_Count_ID_And_ID_Reward_Type[0], Number(cur_pack)]
                    });
                    
                    let add_ = await client.readContract({
                        address: Gen_8.address,
                        abi: Gen_8.abi,
                        functionName: "GetID_Add",
                        args: [Upid_Pack_Count_ID_And_ID_Reward_Type[0]]
                    });
               
                    Arr.push({
                        sr: i,
                        id: Upid_Pack_Count_ID_And_ID_Reward_Type[0],
                        add: Sub_Variable(add_),
                        rank: cur_pack,
                        total_reward: Is_Value_Format_Without_Symbol(Upid_ID_Pack_Total_Reward_And_Total_Received_Count[0]),
                        total_retopup_received: Number(Upid_ID_Pack_Total_Reward_And_Total_Received_Count[1]),
                        reward_type: Upid_Pack_Count_ID_And_ID_Reward_Type[1]
                    });
                }
                else {
                    break;
                }
            }
            // console.log(Arr);
            SetLevel_Downline_Detail(Arr);
            SetLevel_Downline_Is("");
            // console.log(Level_Downline_Detail);
        }
        catch(error) {
            console.log(error);
            SetLevel_Downline_Detail([]);
            SetLevel_Downline_Is("");

            SetLevel_Downline_ID_Detail([]);
            SetLevel_Downline_ID_Is("");
        }
    }

    const Next = async() => {
        let nextpage = Number(Number(Current_Page) + Number(1));
        if(Number(nextpage) > Number(Total_Page)) {

        }
        else if(Number(nextpage) <= Number(Total_Page)) {
            SetCurrent_Page(nextpage);
            Current_Page_Detail(nextpage, Number(Current_Pack));
        }
    }
    const Pre = async() => {
        let prepage = Number(Number(Current_Page) - Number(1));
        if(Number(prepage) < Number(1)) {

        }
        else if(Number(prepage) >= Number(1)) {
            SetCurrent_Page(prepage);
            Current_Page_Detail(prepage, Number(Current_Pack));
        }
    }

    useEffect(() => {
        if(props.ID_) {
            First_Load_Pack(1);
        }
    }, [props.ID_]);

    return (
        <>
            {/* <!----Matrix---Level----Income------------------------> */}
            {/* <div className="hide-space"></div> */}
            <div className="back-grid-short">                                 
                <div className="heading">
                    <span>Level Income</span>
                </div>
            </div>
            <div className="back-grid-short scroll-bar">
                <div className="check-level">
                    <span><button className="click-level" onClick={() => {Select_Pack(Number(1));}}>1</button></span>
                    <span><button className="click-level" onClick={() => {Select_Pack(Number(2));}}>2</button></span>
                    <span><button className="click-level" onClick={() => {Select_Pack(Number(3));}}>3</button></span>
                    <span><button className="click-level" onClick={() => {Select_Pack(Number(4));}}>4</button></span>
                    <span><button className="click-level" onClick={() => {Select_Pack(Number(5));}}>5</button></span>
                    <span><button className="click-level" onClick={() => {Select_Pack(Number(6));}}>6</button></span>
                    <span><button className="click-level" onClick={() => {Select_Pack(Number(7));}}>7</button></span>
                    <span><button className="click-level" onClick={() => {Select_Pack(Number(8));}}>8</button></span>
                </div>    
            </div> 
            <div className="back-grid-short">                      
                <div className="heading">
                    <div className="card-next-previous">
                        <span><button className="click-level" onClick={() => {Pre();}}>Prev</button></span>
                        <span>{Current_Page} / {Total_Page}</span>
                        <span><button className="click-level" onClick={() => {Next();}}>Next</button></span>
                    </div>
                </div>
            </div>
            <div className="back-grid">  
                <div className="table scroll-bar">     
                    <table>                                                                                                                                                                                      
                        <thead>
                            <tr key={"ma_1"}>
                                <td>Sr</td>
                                <td>ID</td>
                                <td>Address</td>
                                <td>Rank</td>
                                <td>TopUp</td>
                                <td>Income</td>
                                <td>Tikker</td>
                                <td>Type</td>
                                <td>Detail</td>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                Level_Downline_Is === "" ? (
                                    <>
                                        {
                                            Level_Downline_Detail.map((data) => {
                                                return (
                                                    <>
                                                        <tr key={data.id}>
                                                            <td>{data.sr}</td>
                                                            <td>{data.id}</td>
                                                            <td>{data.add}</td>
                                                            <td>Rank {data.rank}</td>
                                                            <td>{data.total_retopup_received}</td>
                                                            <td>{data.total_reward}</td>
                                                            <td>CORE</td>
                                                            <td>{data.reward_type}</td>
                                                            <td><div onClick={() => {ID_Detail(props.ID_, data.id, data.rank, data.total_retopup_received)}}><a className="claim">Detail</a></div></td>
                                                        </tr>
                                                    </>
                                                );
                                            })
                                        }
                                    </>
                                ) : (
                                    <>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>{Level_Downline_Is}</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    </>
                                )
                            }
                        </tbody>

                    </table>
                </div> 
            </div>
            <div className="back-grid">  
                <div className="table scroll-bar">
                    <table>                                                                                                                                                                                      
                        <thead>
                            <tr>
                                <td>Sr</td>
                                <td>ID</td>
                                <td>Rank</td>
                                <td>TopUp</td>
                                <td>Income</td>
                                <td>Tikker</td>
                                <td>TIME</td>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                Level_Downline_ID_Is === "" ? (
                                    <>
                                        {
                                            Level_Downline_ID_Detail.map((data) => {
                                                return (
                                                    <>
                                                        <tr key={data.id}>
                                                            <td>{data.sr}</td>
                                                            <td>{data.id}</td>
                                                            <td>{data.rank}</td>
                                                            <td>{data.topup}</td>
                                                            <td>{data.reward}</td>
                                                            <td>CORE</td>
                                                            <td>{data.time}</td>
                                                        </tr>
                                                    </>
                                                );
                                            })
                                        }
                                    </>
                                ) : (
                                    <>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>{Level_Downline_ID_Is}</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    </>
                                )
                            }
                        </tbody>
                    </table>
                </div> 
            </div>
        </>
    );
}

//----Pool--------

export function Pool_Income_Form(props) {

    const {address} = useAccount();

    const [Total_Cycle_No_Loading, SetTotal_Cycle_No_Loading] = useState(true);
    const [Total_Cycle_No, SetTotal_Cycle_No] = useState([]);

    const [Detail_Loading, SetDetail_Loading] = useState(true);
    const [Detail, SetDetail] = useState([]);
    
    const Claim = async(id, count, lvl) => {
        try {
            if (window.ethereum) {
                props.SetLoadingModal(true, true);
                // Delcalre a Wallet Client
                const walletClient = createWalletClient({
                    account: address,
                    chain: p_chain,
                    transport: custom(window.ethereum)
                });

                try {
                    props.SetLoadingModal(true, true);//false);
                    let request_writeContract = await walletClient.writeContract({
                        address: Fixed_Pool.address,
                        abi: Fixed_Pool.abi,
                        functionName: "Claim",
                        args: [id, count, lvl],

                        maxPriorityFeePerGas: BigInt(60e9), // required minimum
                        maxFeePerGas: BigInt(150e9),    
                    });
                    props.SetLoadingModal(true, true);            
        
                    // console.log(request_writeContract);
                    
                    const transaction = await client.waitForTransactionReceipt({confirmations: 5, hash: request_writeContract});
                    // console.log("Transaction is : ");
                    // console.log(transaction);
                    if (transaction.status === "success") {
                        props.SetLoadingModal(false, false);
                        props.showAlert("FixPool: Cycle: " +count+ " Level: "+lvl+" Reward Claimed!...", "success", true);
                        setTimeout(() => {
                            if(props.Should === true) {
                                props.SetShould(false);
                            }
                            else if(props.Should === false) {
                                props.SetShould(true);                        
                            }
                        }, [2000]);
                    }
                    else {
                        props.SetLoadingModal(false, false);
                        props.showAlert("Transaction Reverted!...", "danger", true);
                    }
                }
                catch {
                    props.SetLoadingModal(false, false); 
                    props.showAlert("Transaction Reverted!...", "danger", true);
                }
            }
            else {
                props.SetLoadingModal(false, false);
                props.showAlert("Please SignUp Through DAPPS!...", "warning", false);
            }
        }
        catch(error) {
            console.log(error);
            props.SetLoadingModal(false, false);
        }
    }

    const By_ID = async() => {
        try {
            SetTotal_Cycle_No_Loading(true);
            SetDetail_Loading("");
            SetDetail([]);

            let Total_ID_Cycle_Count = await client.readContract({
                address: Fixed_Pool_Data.address,
                abi: Fixed_Pool_Data.abi,
                functionName: "Get_Total_ID_Cycle_Count",
                args: [props.ID_]
            });

            // console.log("FixPool: Total_ID_Cycle: " + Total_ID_Cycle_Count);

            let Arr = [];

            for(let i = 1; i <= Number(Total_ID_Cycle_Count); i++) {
                Arr.push({
                    cycle: Number(i)
                });
            }

            // console.log(Arr);
            SetTotal_Cycle_No(Arr);
            SetTotal_Cycle_No_Loading();
            // console.log(Total_Cycle_No);
        }
        catch(error) {
            console.log(error);
            SetTotal_Cycle_No([]);
            SetTotal_Cycle_No_Loading();
        }
    }
    const By_Count = async(count) => {
        try {
            SetDetail_Loading(true);  // explicitly set loading
            SetDetail([]);            // clear old detail
            let Arr = [];

            if(props.ID_Type_ === false) {
                // console.log("ID_Type: " + props.ID_Type_);
                for(let lvl = 1; lvl <= Number(8); lvl++) {
                    let ID_Cycle_Lvl_ = await client.readContract({
                        address: Fixed_Pool.address,
                        abi: Fixed_Pool.abi,
                        functionName: "GetID_Cycle_Lvl_",
                        args: [props.ID_, count, lvl]
                    });

                    let Is_Claimed;
                    let Should_Claim;
                    let Sh_Show;

                    console.log(ID_Cycle_Lvl_);

                    if(ID_Cycle_Lvl_[3] == true) {
                        Is_Claimed = "Claimed";
                        Should_Claim = false;
                        Sh_Show = "";
                    }
                    else if(ID_Cycle_Lvl_[3] == false) {
                        let ID_Cycle_Lvl_Wallet = await client.readContract({
                            address: Fixed_Pool.address,
                            abi: Fixed_Pool.abi,
                            functionName: "GetID_Cycle_Lvl_Wallet",
                            args: [props.ID_, count, lvl]
                        });

                        if(Number(ID_Cycle_Lvl_Wallet) > Number(0)) {
                            let User_Pack_No = await client.readContract({
                                address: Gen_8.address,
                                abi: Gen_8.abi,
                                functionName: "GetUser_Pack_No",
                                args: [props.ID_]
                            });
                            let FixPool_Certain_Pack_Id_Count = await client.readContract({
                                address: Gen_8_Cal.address,
                                abi: Gen_8_Cal.abi,
                                functionName: "GetFixPool_Certain_Pack_Id_Count",
                                args: [props.ID_, Number(User_Pack_No)]
                            });
                            if(Number(User_Pack_No) >= Number(4) && Number(FixPool_Certain_Pack_Id_Count) >= Number(4)) {
                                Is_Claimed = "UnClaimed";
                                Should_Claim = true;
                                Sh_Show = "";
                            }
                            else {
                                Is_Claimed = "UnClaimed";
                                Should_Claim = false;
                                Sh_Show = "Isn't Eligible";
                            }
                        }
                        else {
                            Is_Claimed = "UnClaimed";
                            Should_Claim = false;
                            Sh_Show = "";
                        }                   
                    }
                    // console.log(Is_Claimed + " || " + Should_Claim + " || " + Sh_Show);

                    if(Number(ID_Cycle_Lvl_[1]) > Number(0)) {
                        Arr.push({
                            lvl: Number(lvl),
                            esti_id: Number(ID_Cycle_Lvl_[1]),
                            total_id: Number(ID_Cycle_Lvl_[0]),
                            income: (Is_Value_Format(ID_Cycle_Lvl_[2])),
                            status: Is_Claimed,
                            should_claim: Should_Claim,
                            sel_count: count,
                            should_show: Sh_Show
                        });
                        // console.log(Arr);
                    }
                    else if(Number(ID_Cycle_Lvl_[1]) === Number(0)) {
                        for(let rest = (lvl); rest <= Number(8); rest++) {
                            // console.log(Arr[1]);
                            // console.log(Arr[2]);
                            // console.log("rest: " + Number(rest) + " || rest-3: " + Number(rest-2));
                            // console.log("Arr["+Number(rest-2)+"]");
                            // console.log(Arr[Number(rest-2)]);

                            // console.log("lvl: " + Number(lvl) + " || lvl-1: " + Number(lvl-1));
                            // console.log("Arr["+Number(lvl-1)+"]");
                            // console.log(Arr[Number(lvl-2)]);
                            if(Number(rest) > Number(1)) {
                                Arr.push({
                                    lvl: Number(rest),
                                    esti_id: Number(Arr[Number(rest-2)].esti_id * 4),
                                    total_id: Number(0),
                                    income: (Is_Value_Format(0)),
                                    status: "UnClaimed",
                                    should_claim: false,

                                    sel_count: count
                                }); 
                                // {console.log(Arr[1]);
                                // console.log(Arr[2]);
                                // console.log("rest: " + Number(rest) + " || rest-2: " + Number(rest-2));
                                // console.log("Arr["+Number(rest-2)+"]");
                                // console.log(Arr[Number(rest-3)]);

                                // // console.log("lvl: " + Number(lvl) + " || lvl-1: " + Number(lvl-1));
                                // // console.log("Arr["+Number(lvl-1)+"]");
                                // // console.log(Arr[Number(lvl-2)]);
                                // Arr.push({
                                //     lvl: Number(rest),
                                //     esti_id: Number(Arr[Number(rest-3)].esti_id * 4),
                                //     total_id: Number(0),
                                //     income: (Is_Value_Format(0)),
                                //     status: "UnClaimed",
                                //     should_claim: false,

                                //     sel_count: count
                                // }); }
                            }
                            else if(Number(rest) === Number(1)) {
                                Arr.push({
                                    lvl: Number(rest),
                                    esti_id: Number(4),
                                    total_id: Number(0),
                                    income: (Is_Value_Format(0)),
                                    status: "UnClaimed",
                                    should_claim: false,

                                    sel_count: count
                                }); 
                            }
                        }
                        break;
                    }
                }
            }
            else if(props.ID_Type_ === true) {
                console.log("ID_Type: " + props.ID_Type_);
                for(let lvl = 1; lvl <= Number(8); lvl++) {
                    let ID_Cycle_Lvl_ = await client.readContract({
                        address: Fixed_Pool.address,
                        abi: Fixed_Pool.abi,
                        functionName: "GetID_Cycle_Lvl_",
                        args: [props.ID_, count, lvl]
                    });

                    let Is_Claimed;
                    let Should_Claim;
                    let Sh_Show;

                    console.log(ID_Cycle_Lvl_);

                    if(ID_Cycle_Lvl_[3] == true) {
                        Is_Claimed = "Claimed";
                        Should_Claim = false;
                        Sh_Show = "";
                    }
                    else if(ID_Cycle_Lvl_[3] == false) {
                        
                        let ID_Cycle_Lvl_Wallet = await client.readContract({
                            address: Fixed_Pool.address,
                            abi: Fixed_Pool.abi,
                            functionName: "GetID_Cycle_Lvl_Wallet",
                            args: [props.ID_, count, lvl]
                        });

                        if(Number(ID_Cycle_Lvl_Wallet) > Number(0)) {
                            let User_Pack_No = await client.readContract({
                                address: Gen_8.address,
                                abi: Gen_8.abi,
                                functionName: "GetUser_Pack_No",
                                args: [props.ID_]
                            });
                            let FixPool_Certain_Pack_Id_Count = await client.readContract({
                                address: Gen_8_Cal.address,
                                abi: Gen_8_Cal.abi,
                                functionName: "GetFixPool_Certain_Pack_Id_Count",
                                args: [props.ID_, Number(4)]
                            });
                            
                            if(Number(User_Pack_No) >= Number(4) && Number(FixPool_Certain_Pack_Id_Count) >= Number(4)) {
                                Is_Claimed = "UnClaimed";
                                Should_Claim = true;
                                Sh_Show = "";
                            }
                            else {
                                Is_Claimed = "UnClaimed";
                                Should_Claim = false;
                                Sh_Show = "Isn't Eligible";
                            }
                        }
                        else {
                            Is_Claimed = "UnClaimed";
                            Should_Claim = false;
                            Sh_Show = "";
                        } 
                    }

                    if(Number(ID_Cycle_Lvl_[1]) > Number(0)) {
                        Arr.push({
                            lvl: Number(lvl),
                            esti_id: Number(ID_Cycle_Lvl_[1]),
                            total_id: Number(ID_Cycle_Lvl_[0]),
                            income: (Is_Value_Format(ID_Cycle_Lvl_[2])),
                            status: Is_Claimed,
                            should_claim: Should_Claim,

                            sel_count: count,
                            should_show: Sh_Show
                        }); 
                    }
                    else if(Number(ID_Cycle_Lvl_[1]) === Number(0)) {
                        for(let rest = (lvl); rest <= 8; rest++) {
                            // console.log("rest: " + Number(rest) + " || rest-2: " + Number(rest-2));
                            // console.log("Arr["+Number(rest-2)+"]");
                            // console.log(Arr[Number(rest-3)]);

                            // console.log("lvl: " + Number(lvl) + " || lvl-1: " + Number(lvl-1));
                            // console.log("Arr["+Number(lvl-1)+"]");
                            // console.log(Arr[Number(lvl-2)]);
                            if(Number(rest) > Number(1)) {
                                Arr.push({
                                    lvl: Number(rest),
                                    esti_id: Number(Arr[Number(rest-2)].esti_id * 4),
                                    total_id: Number(0),
                                    income: (Is_Value_Format(0)),
                                    status: "UnClaimed",
                                    should_claim: false,

                                    sel_count: count
                                }); 
                            }
                            else if(Number(rest) === Number(1)) {
                                Arr.push({
                                    lvl: Number(rest),
                                    esti_id: Number(4),
                                    total_id: Number(0),
                                    income: (Is_Value_Format(0)),
                                    status: "UnClaimed",
                                    should_claim: false,

                                    sel_count: count
                                }); 
                            }
                        }
                        break;
                    }
                }
            }
                
            // console.log("Final Detail Array:", Arr);

            // ✅ Only update state once, and in correct order
            SetDetail(Arr);
            SetDetail_Loading("");   // make sure this matches what you check in JSX
        }
        catch(error) {
            console.log(error);
            SetDetail_Loading();
            SetDetail([]);
        }
    }

    useEffect(() => {
        // let ignore = false; // 🔄 this flag will help ignore the result

        const Load = async() => {
            try {
                // console.log("Pool : ID_Type_: " + props.ID_Type_ + " ")
                if(props.ID_Type_ === true) {
                    //(S1)
                    // console.log("IS_S1: Pack_No: " + Number(6));
                    
                    // if (!ignore) {
                        By_ID();//, Number(1));
                    // }
                }
                else if(props.ID_Type_ === false) {
                    //(S0)
                    // console.log("IS_S0: Pack_No: " + Number(0));
                    
                    // if (!ignore) {
                        By_ID();//, Number(1));
                    // }
                }
            }
            catch(error) {
                // if (!ignore) {
                    console.log(error);
                // }
            }
        }
        Load();

        // 👇 Cleanup function to prevent continuing if effect is cleaned up
        // return () => {
            // ignore = true;
        // };

    }, [props.ID_, props.ID_Type_]);

    useEffect(() => {
        // console.log("Updated Detail:", Detail);
    }, [Detail]);

    return (
        <>
            {/* <!-------Fix---Pool---Rewards---Section----------> */}
            {/* <div className="hide-space"></div> */}
            <div className="back-grid-short">                                 
                <div className="heading">
                    <span>Claim Pool Rewards</span>
                </div>
            </div>
            <div className="back-grid-short scroll-bar">
                <div className="check-level">
                    {  
                        !Total_Cycle_No_Loading ? (
                            Total_Cycle_No.map((data) => {
                                // console.log(data);
                                return (
                                    <span><button className="click-level" key={"fix_pool_" + data.pack + "_" + data.cycle} onClick={() => {By_Count(data.cycle)}}>{data.cycle}</button></span>
                                )
                            })
                        ) : (
                            Loading_Component()
                        )
                    }
                </div> 
            </div> 
            <div className="back-grid">         
                <div className="table scroll-bar">
                    <table>
                        <thead>
                            <tr key={"Pool_1"}>
                                <td>Level</td>
                                <td>Estimated ID</td>
                                <td>Total ID</td>  
                                <td>Rewards</td>
                                <td>Status</td>
                                <td>Claim</td>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                !Detail_Loading ? (
                                    Detail.map((data) => {
                                        // console.log(data);
                                        return (
                                            <tr key={data.no+data.status}>
                                                <td>{data.lvl}</td>
                                                <td>{data.esti_id}</td>
                                                <td>{data.total_id}</td>
                                                <td>{data.income}</td>
                                                <td>{data.status}</td>
                                                <td>
                                                    {
                                                        data.should_claim === true ? (
                                                            <>
                                                                <div onClick={() => {Claim(props.ID_, data.sel_count, data.lvl)}}>
                                                                    <a className="claim">Claim</a>
                                                                </div> 
                                                            </>
                                                        ) : (
                                                            <>
                                                                <div>{data.should_show}</div> 
                                                            </>
                                                        )
                                                    }
                                                </td>
                                            </tr>
                                        );
                                    })                 
                                ) : (
                                    <tr><td colSpan="7">{Loading_Component()}</td></tr>
                                )
                            }                           
                        </tbody>
                    </table>
                </div>
            </div> 
        </>
    );
}

//----Team--------

export function Team_Tree_Form(props) {

    let id_class = "card-tree-id";
    let blank = "card-tree-id-blank";

    let zero_rank = "";//"RANK 0";
    let Rank_ = "RANK ";

    const[TN0_ClassName, SetTN0_ClassName] = useState();
    const[TN0_ID, SetTN0_ID] = useState("");
    const[TN0_Rank, SetTN0_Rank] = useState(zero_rank);
    const[TN0_Is, SetTN0_Is] = useState("Vacant");

    const[TN1_ClassName, SetTN1_ClassName] = useState(blank);
    const[TN1_ID, SetTN1_ID] = useState("");
    const[TN1_Rank, SetTN1_Rank] = useState(zero_rank);
    const[TN1_Is, SetTN1_Is] = useState("Vacant");
    
    const[TN2_ClassName, SetTN2_ClassName] = useState(blank);
    const[TN2_ID, SetTN2_ID] = useState("");
    const[TN2_Rank, SetTN2_Rank] = useState(zero_rank);
    const[TN2_Is, SetTN2_Is] = useState("Vacant");

    const[Total_Node, SetTotal_Node] = useState(Number(0));
    const[Detail_Arr, SetDetail_Arr] = useState([]);

    const Tree_Structure = async(id) => {
        try {

            SetTN0_ID(Card_LC());
            SetTN1_ID(Card_LC());
            SetTN2_ID(Card_LC());
            
            SetTN0_Rank(zero_rank);
            SetTN1_Rank(zero_rank);
            SetTN2_Rank(zero_rank);

            SetTotal_Node(Number(0));
            SetDetail_Arr([]);

            let tn0_id_exist = await client.readContract({
                address: Gen_8.address,
                abi: Gen_8.abi,
                functionName: "GetID_Exist",
                args: [id]
            });
            let tn0_Pack_No = await client.readContract({
                address: Gen_8.address,
                abi: Gen_8.abi,
                functionName: "GetUser_Pack_No",
                args: [id]
            });
            

            if(tn0_id_exist === true) {
                SetTN0_ClassName(id_class);
                SetTN0_ID(id);
                SetTN0_Rank(Rank_ + tn0_Pack_No);
                SetTN0_Is("Tree");

                SetTN1_ID(Card_LC());
                SetTN2_ID(Card_LC());

                let TN1_ID = await client.readContract({
                    address: Gen_8.address,
                    abi: Gen_8.abi,
                    functionName: "GetDSG_UpidNode",
                    args: [Number(1), id, Number(1)]
                });
                let TN2_ID = await client.readContract({
                    address: Gen_8.address,
                    abi: Gen_8.abi,
                    functionName: "GetDSG_UpidNode",
                    args: [Number(1), id, Number(2)]
                });
                let tn1_Pack_No = await client.readContract({
                    address: Gen_8.address,
                    abi: Gen_8.abi,
                    functionName: "GetUser_Pack_No",
                    args: [TN1_ID]
                });
                let tn2_Pack_No = await client.readContract({
                    address: Gen_8.address,
                    abi: Gen_8.abi,
                    functionName: "GetUser_Pack_No",
                    args: [TN2_ID]
                });
                    
                if(TN1_ID !== "") {
                    SetTN1_ClassName(id_class);
                    SetTN1_ID(TN1_ID);
                    SetTN1_Rank(Rank_ + tn1_Pack_No);
                    SetTN1_Is("Tree");
                }
                else {
                    SetTN1_ClassName(blank);
                    SetTN1_ID("");
                    SetTN1_Rank(zero_rank);
                    SetTN1_Is("Vacant");
                }

                if(TN2_ID !== "") {            
                    SetTN2_ClassName(id_class);
                    SetTN2_ID(TN2_ID);
                    SetTN2_Rank(Rank_ + tn2_Pack_No);
                    SetTN2_Is("Tree");
                }
                else {
                    SetTN2_ClassName(blank);
                    SetTN2_ID("");
                    SetTN2_Rank(zero_rank);
                    SetTN2_Is("Vacant");
                }

                let DSG_Upid = await client.readContract({
                    address: Gen_8.address,
                    abi: Gen_8.abi,
                    functionName: "GetDSG_Upid",
                    args: [Number(1), id]
                });
                // console.log("DSG_Upid: " + Number(DSG_Upid));

                let Arr = [];
                if(Number(DSG_Upid) > 2) {
                    for(let i = 3; i <= Number(DSG_Upid); i++) {
                        let TN_ID = await client.readContract({
                            address: Gen_8.address,
                            abi: Gen_8.abi,
                            functionName: "GetDSG_UpidNode",
                            args: [Number(1), id, Number(i)]
                        });
                        let tn_Pack_No = await client.readContract({
                            address: Gen_8.address,
                            abi: Gen_8.abi,
                            functionName: "GetUser_Pack_No",
                            args: [TN_ID]
                        });

                        Arr.push({
                            id_class_: id_class,
                            tn_id_: TN_ID,
                            tn_rank_: Rank_ + tn_Pack_No,
                            tn_is_: "Tree"
                        });
                    }
                }

                // console.log("DSG_Upid: " + Number(DSG_Upid));
                // console.log("Arr:");
                // console.log(Arr);
                SetTotal_Node(Number(DSG_Upid));
                SetDetail_Arr(Arr);
            }
            else {
                SetTN0_ClassName(blank);
                SetTN0_ID("");
                SetTN0_Rank(zero_rank);
                SetTN0_Is("Vacant");
            
                SetTN1_ClassName(blank);
                SetTN1_ID("");
                SetTN1_Rank(zero_rank);
                SetTN1_Is("Vacant");
                
                SetTN2_ClassName(blank);
                SetTN2_ID("");
                SetTN2_Rank(zero_rank);
                SetTN2_Is("Vacant");

                SetTotal_Node(Number(0));
                SetDetail_Arr([]);
            }
            
        }
        catch(error) {
            console.log(error);
            
            SetTN0_ClassName(blank);
            SetTN0_ID("");
            SetTN0_Rank(zero_rank);
            SetTN0_Is("Vacant");
        
            SetTN1_ClassName(blank);
            SetTN1_ID("");
            SetTN1_Rank(zero_rank);
            SetTN1_Is("Vacant");
            
            SetTN2_ClassName(blank);
            SetTN2_ID("");
            SetTN2_Rank(zero_rank);
            SetTN2_Is("Vacant");
        }
    }

    const My_ID = async() => {
        try {
            Tree_Structure(props.ID_);
        }
        catch(error) {
            console.log(error);
        }
    }
    const Search = async() => {
        try {
            let search_id_input = document.getElementById("search_id_input").value;

            let id_exist = await client.readContract({
                address: Gen_8.address,
                abi: Gen_8.abi,
                functionName: "GetID_Exist",
                args: [search_id_input]
            });
            if(id_exist === true) {
                
                let ID_Upid = search_id_input;
                let should = false;

                for(let i = 1; i <= 4; i++) {
                    if(Number(i) < Number(4)) {
                        
                        ID_Upid = await client.readContract({
                            address: Gen_8.address, 
                            abi: Gen_8.abi,
                            functionName: "GetID_Upid",
                            args: [ID_Upid]
                        });

                        if(ID_Upid === props.ID_) {
                            should = true;
                            break;
                        }
                    }
                    else if (Number(i) === Number(4)) {
                        should = false;
                        break;
                    }                    
                }
                
                if(should === true) {
                    Tree_Structure(search_id_input);
                }
                else if (should === false) {
                    props.showAlert("ID Doesn't Exist In Your Tree", "danger", true);
                }
            }
            else {
                props.showAlert("Doesn't Exist", "danger", true);
            }         
        }
        catch(error) {
            console.log(error);
        }
    }

    useEffect(() => {
        if(props.ID_) {
            My_ID();
        }
    }, [props.ID]);

    return (
        <>
            {/* <div className="hide-space"></div> */}
            <div className="back-grid-short">                                 
                <div className="heading">
                    <span>Community</span>
                </div>
            </div>         
            <div className="back-grid-short">
                <div className="back-grid-short-tree"> 
                    <div className="back-grid-tree-blank">
                        <span></span>
                    </div>
                    <div className="back-grid-tree-id-search">
                        <div className="card-search">
                            <div className="search">
                                <input type="text" id='search_id_input' name="search" placeholder="Search here"/>
                                <label for="search">
                                </label>
                            </div> 
                            <div className="search-id">
                                <button className="myid" onClick={() => {My_ID();}}>
                                    <div>My ID</div>
                                </button>
                                <button className="team-id-search" onClick={() => {Search();}}>
                                    <div>Search</div>
                                </button>    
                            </div>
                        </div> 
                    </div>
                    <div className="back-grid-tree-blank">
                        <span></span>
                    </div>
                </div>
            </div>

            <div className="hide-space"></div>    
            <div className="back-grid">
                <div className="back-grid-short-tree"> 
                    <div className="back-grid-tree-blank">
                        <span></span>
                    </div>
                    <div className="back-grid-tree-id">
                        <div className="card-tree-id-main"></div>
                        <div className="tree-id">{TN0_ID}</div>
                        <div className="rank-id">{TN0_Rank}</div>
                        <div className="tree-id-btn"><button disabled={true}>{TN0_Is}</button></div> 
                    </div>
                    <div className="back-grid-tree-blank">
                        <span></span>
                    </div>
                </div>

                <div className="back-grid-short-tree scroll-bar"> 
                    <div className="back-grid-tree-blank">
                        <span></span>
                    </div>
                    <div className="back-grid-tree-id">
                        <div className={TN1_ClassName}></div>
                        <div className="tree-id">{TN1_ID}</div>
                        <div className="rank-id">{TN1_Rank}</div>
                        <div className="tree-id-btn"><button disabled={TN1_Is==="Vacant"} onClick={() => {Tree_Structure(TN1_ID);}}>{TN1_Is}</button></div> 
                    </div>
                    <div className="back-grid-tree-blank">
                        <span></span>
                    </div>

                    <div className="back-grid-tree-id">
                        <div className={TN2_ClassName}></div>
                        <div className="tree-id">{TN2_ID}</div>
                        <div className="rank-id">{TN2_Rank}</div>
                        <div className="tree-id-btn"><button disabled={TN2_Is==="Vacant"} onClick={() => {Tree_Structure(TN2_ID);}}>{TN2_Is}</button></div> 
                    </div>
                    <div className="back-grid-tree-blank">
                        <span></span>
                    </div>

                    {
                        Number(Total_Node) > Number(2) ? (
                            <>
                                {
                                    Detail_Arr.map((data) => {
                                        return (
                                            <>
                                            {/* // <div key={data.tn_id_+data.id_class_+data.tn_rank_}> */}
                                                <div className="back-grid-tree-id">
                                                    <div className={data.id_class_}></div>
                                                    <div className="tree-id">{data.tn_id_}</div>
                                                    <div className="rank-id">{data.tn_rank_}</div>
                                                    <div className="tree-id-btn"><button disabled={data.tn_is_==="Vacant"} onClick={() => {Tree_Structure(data.tn_id_);}}>{data.tn_is_}</button></div> 
                                                </div>
                                                <div className="back-grid-tree-blank">
                                                    <span></span>
                                                </div>
                                            {/* // </div> */}
                                            </>
                                        );
                                    })
                                }
                            </>
                        ) : (
                            <></>
                        )
                    }
                    

                </div>
            </div>
            
        </>
    );
}


//---------------------Before-Login---------

//-----Refferal_Area-------------------------

async function Generate_ID() {
    let result = '';
    const characters = '0123456789';
    const charactersLength = characters.length;
    for(let c = 1; c <= Number(8); c++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}
export async function Refferal_Detail(id, SetUpline_ID, open, showAlert, SetLoadingModal) {
    try {
      SetLoadingModal(true, true);
      let id_exist = await client.readContract({
        address: Gen_8.address,
        abi: Gen_8.abi,
        functionName: "GetID_Exist",
        args: [id]
      });
  
      if (id_exist === true) {
        SetUpline_ID(id);
        SetLoadingModal(false, true); 
        open();        
      }
      else if (id_exist === false) {
        SetLoadingModal(false, false);  
        showAlert("Doesn't Exist", "danger", true);
      }
    }
    catch(error) {
      SetLoadingModal(false, false);    
    }
}
export async function Refferal_SignUp(address, Upline_ID, showAlert, SetLoadingModal) {
    try {
      SetLoadingModal(true, true);
      let add_detail = await client.readContract({
        address: Gen_8.address,
        abi: Gen_8.abi,
        functionName: "GetAdd_Exist",
        args: [address]
      }); 
  
      if (add_detail === true) {
        SetLoadingModal(false, false);
        //showAlert("You Already Exist!...", "danger", true);
        window.location.replace(url);
      }
      else {
        SetLoadingModal(true, true);
        if (window.ethereum) {
            // Delcalre a Wallet Client
            const walletClient = createWalletClient({
                account: address,
                chain: p_chain,
                transport: custom(window.ethereum)
            });
    
            //console.log("WalletClient");
            //console.log(walletClient);
            let id_;
            do{
                id_ = await Generate_ID();
                let id_exist = await client.readContract({
                    address: Gen_8.address,
                    abi: Gen_8.abi,
                    functionName: "GetID_Exist",
                    args: [id_]
                });
                if (id_exist === false) {
                    break;
                }
            }
            while(true);

            let core_amount = BigInt(40000000000000000000); //--40--
            // let core_amount = BigInt(400000000000000000); //--0.40--

            // console.log(core_amount);


            SetLoadingModal(true, true);
            let User_Core_BalanceOf = await client.getBalance({address: address});
            // console.log(Number(User_Core_BalanceOf));

            // console.log('address: ' + address + ' id_: ' + id_ + " Upline_ID: " + Upline_ID);

            //--

            if(BigInt(User_Core_BalanceOf) > BigInt(core_amount)) {
                // console.log(BigInt(User_Core_BalanceOf) + " is greater than " + BigInt(core_amount))
                try {
                    SetLoadingModal(true, false);
                    
                    let request_writeContract = await walletClient.writeContract({
                        address: Gen_8.address,
                        abi: Gen_8.abi,
                        functionName: "Activate_First",
                        args: [address, id_, Upline_ID],
                        value: BigInt(core_amount),
                        
                        maxPriorityFeePerGas: BigInt(60e9), // required minimum
                        maxFeePerGas: BigInt(150e9),   
                    });

                    SetLoadingModal(true, true);
                    // console.log(request_writeContract);
                
                    const transaction = await client.waitForTransactionReceipt({confirmations: 5, hash: request_writeContract});
            
                    if(transaction.status === "success") {
                        SetLoadingModal(false, false);
                        showAlert("SignedUp!...", "success", true);
                        setTimeout(() => {
                            window.location.replace(url);
                        }, [2000]);
                    }
                    else {
                        SetLoadingModal(false, false);
                        showAlert("Transaction Reverted!...", "danger", true);
                    }
                }
                catch {
                    SetLoadingModal(false, false); 
                    showAlert("Transaction Reverted!...", "danger", true);
                }
            }
            else {
                SetLoadingModal(false, false);
                showAlert("Insufficient Balance!...", "danger", true);
            }
        }
        else {
          SetLoadingModal(false, false);
          showAlert("Please SignUp Through DAPPS!...", "warning", false);
        }
      }
    
    }
    catch(error) {
      //console.log("Step Falied");
      console.log(error);
      //showAlert(error.toString(), "danger", false);
      SetLoadingModal(false, false);
    }
}

//-----Login_Area----------------------------

export async function Login_Detail(address, SetIsLogin, showAlert) {
    try {
      let add_detail = await client.readContract({
        address: Gen_8.address,
        abi: Gen_8.abi,
        functionName: "GetAdd_Exist",
        args: [address]
      });      
      
      if (add_detail === false) {
        SetIsLogin(false);
        showAlert("You Doesn't Exist!...", "danger", true);
      }
      else if (add_detail === true) {
        SetIsLogin(true);
        showAlert("Logined!...", "success", true);
      }
    }
    catch (error) {
        console.log(error);
    }
}

//----After_Login--------

export async function Address_ID_Detail(address, SetID_, SetID_Type_, SetWallet_Bal) {
    try {
        let Add_ID = await client.readContract({
            address: Gen_8.address,
            abi: Gen_8.abi,
            functionName: "GetAdd_ID",
            args: [address]
        });
        // console.log(Add_ID);
        SetID_(Add_ID);

        let ID_Type = await client.readContract({
            address: Gen_8.address,
            abi: Gen_8.abi,
            functionName: "GetUser_ID_Type",
            args: [Add_ID]
        });

        let Set_ID_Type_as = true;
        if(ID_Type === "S0") {
            Set_ID_Type_as = false;
        }
        else if(ID_Type === "S1") {
            Set_ID_Type_as = true;
        }

        SetID_Type_(Set_ID_Type_as);

        
        let User_BalanceOf = await client.getBalance({address: address});
        SetWallet_Bal(Format_Core(User_BalanceOf));
    }
    catch(error) {
        console.log(error);
    }
}
